import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.string.fixed.js";
import "core-js/modules/es6.array.map.js";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TableRow from './TableRow';
import TableHeader from './TableHeader';
import { measureScrollbar, debounce, warningOnce, getMaxColChildrenLength } from './lib/utils';
import shallowequal from 'shallowequal';
import ColumnManager from './ColumnManager';
import createStore from './createStore';
import Loading from '../../wui-spin/src';
import Icon from '../../wui-icon/src';
import { Event, EventUtil, closest, myBrowser } from "./lib/utils";
import i18n from "./lib/i18n";
import { getComponentLocale } from "../../wui-locale/src/tool";
import ResizeObserver from 'resize-observer-polyfill';
import DragResizerLine from "./DragResizerLine";
var browserInfo = myBrowser();
import { WebUI, prefix } from "../../wui-core/src/index.js"; //TODO 待提出去

var noDataImg = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHwAAAB4CAYAAAAwj5aoAAAgAElEQVR4Xu2dC5QcV3nn69ajq7qrZzSSJRvZRrYsyZZsyzYwnpFFYkeE+IBh1yEOJnDY8AyQbHLw7gFndwlZNgHWLIc9PJbH4gWze4KzdtjlIVbBeI1gAyPNSLaOx5YtLNvyQ7JeyJpRT7+r6+75tftTSj3V093Tjxk51Dl95tFVt+79/t/73vtdZbyMLq21mclklmmthyzL8k3TTJmmuSQMQz8Mw6RlWU6lUikopXKmac5orTOVSiVr2/ZMLpc7ec4555x6GZEjdijqbB3g9PT0MsuyXuk4zrogCK5WSl2ulHpFpVJZrpRaahhG2jTNpOM41SFqras/lfrHIReLRa2UqgJvGMYJpdSJMAyfMwxj0jCMR23bPuC67nNKqcLZSqf6fp81gGutB6enpy+1bXuLaZqblVKXhWG41nXdKqIACahhGFY//C6fRmDxDB/TNE9/hDl4tlQqTRuG8YTW+lHLsn6ilNrpuu4BpVTlbGWARQ34yZMnhzzPe43W+vdM03xtpVK50nVdC5AqlYoRBMFpye0FADCCbdtVZoCJisXiKdM09yil7q9UKj/Yt2/fvuHh4XIv3t2rNhcd4NjhXC6Hin6HaZpv1FpfkUgkqgQvl8s9BbgZkQFeTESpVELNj2ut/84wjO/6vv9Cs+cXw/eLBnCtdTKfz79Ja/1+pdQNrut6SDEgL8YLLQMjovqDIDhsGMYPwjC80/f9Bxdjf6VPCw74kSNH/CVLlrzdNM0Paq2HUaGlUmlBJbldwCzLqoJfKBTyhmH8SCn15WQy+UC77fTj/gUDXGvtlMvld2itP2ya5qsYLECfzRdS77outj4wDGNbEASfHRwc/PliGlPfAcdGnzhxYtg0zU9YlvVG8a6RbPl9MRFoPn1hHJ7nAXxWKfWVIAj+czqdPjKftrr9TN8AHxsbW09IZVnW72Kjbdt2C4WXwlucoXQ6bZx33nlVCZGYuduD7Xd7jIvxlEolQrv/sHXr1ntuvfXWBQ3pOgZ89+7dZK+GwzC80rKs1YZhLNFaZ03TPBwEwSOGYSyzbRvVvcVxnEG8bZwxLmxfzemp/kwmk8bFF1982hPuN0C9eh+efY2Jf2AYxsdc13201XeNjY1d4Pv+1NVXX51t9Zm57ps34Dt37hw0TfM9hmH8C8MwCJ28qGSi1gqFQsW2bQtgiZlRc6lUyvB9v8r5SABXPp83XnjhBe43zj///Kqkwxgvp0vUfKlUOqa1vj2ZTP73ZuPbsWPHaxOJxHeCINhdqVRu3bx5M05hR9e8AN+5c+eNlmV9yrbtYaSVwSCdgAi4gIUDBoBRtb1y5UpjxYoVs8AE+EOHDhlHjx41li1bZrzyla/saFCL+eGarxKWy+WvlcvlvxgaGjrZqL87dux499DQ0F2ZTOa4YRivGRkZeb7TsbUN+I4dO95vWdYXbdtO8nKkEZAAO5qn5jtAn5qaqgKZzWarEn3uuedWn4lqAwH82LFjxjnnnGNceOGFnY5rUT8vtr1cLo8FQfCnvu/vieswgA8MDNyVzWaPWZZ17fDwMHn+jq62AB8fH3+fbdtfq1Qq9pIlS4xVq1ZV1XSzC3X+/PPPV4GHKS644IIqsAI6Pw8cOGBkMpnqdzDFy02lx9EI2pVKpaNhGP6R7/tb6+8ZHx//kud5f1osFnF6rh8ZGRlrRutm37cM+MTExLWmad6ntV4KWBdddNFpG9zsJfL9s88+axw+fLian77kkkuqZgAGOHXqlPHMM89U25P/n42e+nzCShy6MAyZsfvjZDL5N0Kr7du3DyWTyT22bV+MmSyXy58bGRn5SKu0bnRfS4Dv3bs3kclk7ndd93pU92WXXdY22HQAqX3iiSeMkydPGkuXLq1qCK6nn366Kt1ns/3Gl/nVr35V9VHEGW0VnJpdLwZB8NFUKvUlnpuYmPiIbdufRTvSntb6eLlc3rx58+YnW2037r6WAJ+YmPhnpml+j5B5w4YNVU97vhfS/Mtf/rL6+Jo1a4xcLmccPHiwKvWrV6+utn22STeATE9PV7UUGmpgYKBtk4QUm6YZaq3/enJy8n6tNfReTtRC28ViESnfumzZsreuW7euOF/6twK4Gh8fvyeRSLx1cHCwOqBOLsDct29fdRBDQ0NVZ44JEhy5V7ziFWcd2DKLd+TIkeqY0Fz4IKjqdiUd0KHHgQMHWIhxDskotOnMzExVM9bC2ztN07xteHg4Nx8cmgI+Pj5+jlLqEaXUynXr1hk4a51e2HHsucwzMzCku97L7/Q9/XiecPLEiRPVvosNh6nxc3BAm13yHCZBIhrJWVx66aWnnWIcXmgGIwVB8H/DMPw3mzZtantmringExMTm7XWP00kEs4VV1zRlSwYNhy1LlOMZNfwWM82VQ6Y5BnwPxgTahdHFM0FEzeKYBg3oHKh3ZBgTB3SjcYQTUpb0ev48ePGc8+9FJlVKhUcve9ZlvX9SqWy07btwrFjxzI33XTTnOq+KeC7d+9+UxiGW1OplMJ+t6um6jmcgT711FNVbqYtHDcGeDaCzdhkiRRg4IsQveB8yjKr+vFz/4svvmiQc5DlWBKCMsW6fPlygwQVPk3cBXOQlYTJIlPJORZmaq0ftyzrnXPF63MCPjY2lrRt+9umab4Fblu/fn1HgMPNArakGteuXXtWqvJ6MBgbuQYYuBFYwiDcJ2ZA/gc90Ayt5DZgGNQ7wsO7UPO1VDZM9FsjIyM/a2RK5gR8fHz8c4lE4l+LqkKl4zjM56INwMaxkUkTcuqdOoHz6UuvnkFSm2lAgJEMpKzLI1LhfzyPlJNaJryL046odJgFkEulUlEp9WAYhntM0zyllJocHh6+VynVcCKiIeC7du36A6XUtwnF6AgdvfLKK1vKrNV3FDVErI2Nwq5BFCZM8GZRX2erOu+EcYQxZLYQGmEWAB9ak16OOn0wxP79+6t0C8MQB+BvLcv6/LFjx/Y2s9vRfsYCPj4+zjTnL5LJ5MpCoXCPYRjrlFKvhvMIn9q5xNGgw0g0AKPSUIF45sSs/xQBj7PtSDzeOAkcLpxZ6M3/Ccuw20qpQ2EY3rZp06bvtIOD3DsLcFakjI+PfyOdTr97ZmbmsTAMf9OyrD9yHOcO1AiOWytqHUBxYsQ5IT5FfROS4XQA9Nkais2H0K08I2EdMT10wz5Db2w24R9JqUQi8Y4NGzb8bSvtxd0zC/AHH3zwNWEY/sI0TadUKr3luuuu+8H+/fuvO3Xq1E+DIEigZprFl3jgSDFqCuaAS3FG+D9qCYnGmyWm/7V0z4YFmmCr8XcI79COCBCZyXQ6fbfneX84380QswAfHx//6sDAwIdmZmbuf+aZZ97Ikpx8Pv9fp6enP8CMFgAiqSQW6i8cMyQYNY4HiWePGeBewMZpo/OEHs2YZr4c/HJ4DkmvZdxOp2gBHrrbtl0JguCtqVTqu/MZ6xmA7969e0mlUhnzPO/yYrH4zpGRkW/n8/nXKaV+FIahg9SiXgAdwEiF4nxgYwAZVYRTwf/wMpFq7kU9id0m5pb/z6fD/5SeITeP3eZCcDCLtUzbXs/zflMp1XDxREth2a5duy6pVCqP1tz6V7PCIpfL/cR13U1IL946tgRpRe2gknHEJEvES2QxIjaa/8MI/OTifrxPbNOvVfncrIvQICj4O9CLfIUs8ERz5vP5v/Z9/y/bFYAzJLzmne9VSulisfiqzZs3v8EwjC8ANhedQFXjjAE6F8BJPlgAl7CL5/ie2BK1LlOHvwa7OUzQEG2KLYd+2G/Z6VJbRjZlWdZvuK67t3lr/3jHGYDfd999/tKlS3/ied5IoVD4fxdeeOEa3/cvAGTAQ10TJ5I/lpWncF90JaqASafgSCQdVdTvXHk7EzGLkQEBnPw8ah3aAXhk9WvVP8rlcnel0+n3zhtwHqzNfd9tmmYaoKNLjeR3QOaFqGgA5T6cMZgA4tExPnRUQrh+ELW2UKDan2ieOrptWLRRdItwbS667Tnsdgg9n3tlUQV0JO1avw7QMIxsGIbX+77/UKvtxyZeJicnb04kEvfm8/mEgAyBZJmxzARFpUh+FxUfJXKrnZnvfbybfuIr8EEDEcY0msDgPQI8jImqFE0kad/59qXbz0XpWt92zZZ/0/f997X63ljAC4XCh0zT/EqxWFSyDBlCRG11PyS2lUHIVCPOJHGr5LNFagXcaFvCjPwUc0Q7OKB4w2fL7hfGWKlUpiqVyujg4OATLdGr/iZ2c6bT6THXda9CTc9nYV4rL+7WPfQPTxaPFmnFMcTUAJps5q+f0BCQYWbGSIKI59EMhI2kNNvxAbo1lvm0g5Rns9lPDwwMfKyV52dJeDabfaNpmtsW6zJhAUJ+AtiTTz5ZVeGSe5aBy/5y8S1E2pEMmCE6jYl2IAvIvaR8YZq5TEIrxO3HPYwhCIKni8Xiq5ctW0aJkjmvMwDXWqt8Pv9t13XfLjtGmjXQ6++jS4cAQCIGSTfST+w2dpjZPKScSAIVT9JCGFdMUJRh8EmYzGHBAhcTFEw94iDxEfsuO1ujS5h6Pe5W26dPtm3rIAjelkqlqEbROuDT09NrLcuasCxr6UJLuDhihIOASkiI6gVwpFCkTxgCFb5x48aqJ7t3797q/VGfI44KYu9Z2IEqJwQiWyjAYgpksz8TF6hPPjDXYlL5MG4+n9/q+z47c+fclHeGhE9PT//LVCr1XxZqY35UTQMuEkpOWcIsiC8AALA4V0wp8vtVV11VZY5HH215c2aVccj+8QFw5gJw3gAVOsjCBJhMTAGgwyCyKRJmWkgntrYYdLpcLr9maGjoqblE/DTgWmu7WCxudRznDQuhzmUlCMkGsnjSB9QpHEwoCIH5oGpFzaK+Jycnq/cAOJL92GOPtQwAgLP2m/w+gGMK8NT5iPngHTAeTIjGkQWIvBNbzwcmWCjQoV0tKfPBRCLx9ZYALxQKa4Ig2NVvdS6qG5DJu8vkiyR2sKWAPNeivkceeaRKcAEcld4q8QVwpmujgMuumCjxcAwBn77iN/A770G74AfwaWWtQDM7O5/vYb5cLve9dDp9S0tLnHK53Nsdx7m73+ocImI3ZUIGcJk+JfeOWm12QXS8dO5lHTftIaXtAA5QvI+8NSEeM4HNtizzHnLdsiwJxkEL4QTWLy9uNoZufF/Lrx/LZrPXrFixgqpSsddplZ7NZr/led67+qnOUY9Mm6IuUUmscWPKtRWgZTQAC/GxY3FaIA74Rg6X2Gze32ofUO/E8BLH8xyg16dCuwHqnKr6pZKi1Be9NZVKNVz+VL3r+PHjA8lk8ueSbOlH52AsJAoJxQNGhTLJ0s4VTd9KzB3NoUukEfXoYQwAj+bSJSaPevXteuHYd8aDqqc9/AJA7+dVm1D5Qjqdvm1OCc9kMlfYtr3DMIyBfoRjSAXEwQtHDZIwIZfd7BKAkWhsvczeSUwO6NGQrVl7EnbxMzrhg1nBJkpFi1bBp1+szsXxpD38Atpq1bw062+z7+lvPp//WTqdfr1S6qWtLXVXVcJzudytiUTiHpn3btZwp9/LMig6yMR+M7BFbZMN4yPeclWH1VVJbhWcqEmo/502sImATt/EcZT5hLnGL6Bj3wEb0GUeu1O6NXu+to/8VydPnrx61apVsaVAq4DPzMzc4Xnen/cacAgpa7UAijVaOGiNLu5BerGPZMBkQUWzhEozwrT6vWgUCInZIU+PgzfXzhLaxlyxd07W3qPe+6E5oQtO5NGjRz88MjLyxYYSns1mt3qe9+Z+OGyoclQeQM+1zQgCsT5bqjv1C+S5mI/vMEFin+fSJhAe9Y5qh7F7PQNHX2S7UyaT+eGmTZtujgvPlNbaz2azp2fHWuX+du+jQzAUK1cBk33PjbYei42HaFztqul2+9bO/fQdCccTB/hGfcOXePzxx6t+CvcSffRSymVJFAIShuERrfU1mzZtOjrLhufz+YvCMByzLOt8WbbUDgFavVcW5REjA3SjjYn0AclAhTfbp9Xqu7t9n/gNAEm83gh08gss7Zb9770cD30gxEV71pI/N1977bUUAjzjUtls9lWmaVIdyOslB9IhMlkkWMhbN0psSPKjl8TpFgMAPFOp5A/iLpxLpJyxR1edduv90XbwdWAuftYK/H4lDMOPFIvF8pYtW6gCVT0DRBUKhTdYlvX3vc6wwUxkxFDrbJ+JU+dS/6VfYUynhKefeOCMJ27zP9qKiRycN0LPbu60kcgFepLLwHREVxeHYThtWdZ3tNYPBEGww3GcY9QfUFNTUx/0ff9rvQRc7DeqGuCZt65PPzIAGGIxq/I4BmE82GcAjbtkjr2bdhwfB1sNI8navXqnlr9hRr6vVCovKKV+ppTaxoKHv7Is6+O9PHkgGo7h8Fx++eVVtRO9ZJaLwfTCSZNJmm63LZMnMHFcuCZTroR0mLJOzSb9h0ZEMIS4SHijNhOJREACpla//Wmt9Y+x4d+wbfu9MuXXqZqLjf2UqqocbAyqD8Dl7BC5n1ib77sJCH4ADhMxdG0pUJVIUkulm2NtFHXgk7BxQ4oZdgq49Fm2eKHG8RVISCE0kaiGSlD/wLZvwzC227b95PDw8LTKZDJ/5zjO7/fSQwdE7DOAkn0C8PppRFlt0i1nDZBxDFmoEGUiCI7jSLQgBOoUeNoko4barr9QvYyNhA1qv1uAy3tElUuFDQS3pspjKzci4Vsty3pzLwEHRIjMwJG4uD3m2DrSkZ0CjoolHcpOjXqzUW9CpKJCp1plLjtOGhlG7xXg0TFR90Umb9Lp9O+uX7/++7PCMrYF27b9+oUEHJCkWF+ngPM8MT6M1eyK7ldvdu9c3wM4Nhomq7/6BTjjZqkX70ulUnrNmjW/k06nZx20g4T/H8uyblpowCUr1Ym0QXhJ2bYCYLcYjfciwSzAWCjAoRvhGZnM5cuX61WrVr3OcZyfzpLwTCbzHcdxbnk5AM4YyFu3U4emG4mexQA4wNIPHMQVK1aES5Ysud5xHBy2My4k/Fu2bb+rl156MxuOpHVDwmmHjFZcdYpGEk/6E9vXqWZZaAmX8UGDWjmQ0bhD81Qul7vDtu0/73UcLmEZ3jNOWzRm7RbgcDipznYknPwzHnsnvsNcEk7bMFS3w7JGDAzjaq3LlmVt8Dxv1pJlNT09/WepVOqLvc60ESvirRIy1NdsFVuKh9mppLVjwyEazqKUAW3F7sfdA+AASvHh+kvicJw6wsRuh2X175M16lrr9XFnpZFL/+e2bX+/l4sfolOj/E5Wqj5k6gbhGTzxPV468X6zq1u5e0BkAiWuqiROFEmlfp3WVCvQ8Ax7zeIO0MGGc0ogs2VOL7kPh4pcOZqExEv9sia+I13YiWoVx4UlSVIxoRHoMDhxOJqnG++UzQzR98m2J96BdGPnez0xhAYtFou7fN+/QSk169grJk/W2LY9Ztv2ub301CGEHHWBnWXCIXp1w5ZGHRcpIITPEDUTEJzUKu9DwjsFW5gM6a6fJoWp2BSBQ4wz2Y/dKaSuy+Xy913XfQu1emZ56RzKnkgkfuE4zuW9dtwkMSAebRQI7KjUUG+milv5HmDJ10vt8trm+WpOn3d1c5IGpiGXXq+10FhoLoCu1VjruYTD4DMzM9Ta+5M4OrGIUc3MzNzned7v9NqOywJGCFR/dgrMRmjWzXV10XXrNWemSoNuSHVUm0i6uL5dmRrt1kxZK4xey6PflkqlvtAIcIj8ecdxPtxNYse9DADkfDImGurnkLup1lshTjfuabTqJXqYDyasH+vTa1PAbBe+MS6tynhlmfJ7PM/7Zi8lvPoyparqlFAFFVuvBnHo8NZlb3c3AOllGzi5zMYxjujsH//HPDHW6HFdveyLaC6tNQX0NqZSqYMNJby2rm2n1jrRay+S9klEMH8LsYhdo/u4WIRHKCPFhHpNpPm2L8ub6jdS8H/SmyRc8CHQYv06mqtWNH/i8OHD1zc66qoq4dPT08vIu9q2vb6XjptIOaaDqVJ+krBA5UUXRBC3ogUWM+gwKXPg0f1wgM1sFYBzNTpcd75M1uw5GCuXy33d9/0PNrpXdo8Sj9/red7v99qOC+jYOAgDg0E0iBc9sJa1bbJIoZPsWzMitfN9LU99urwXGkouvH7A5iPTpXELItp5Xzv3QiPMSrFYfN/g4OA3mwFObPqhRCLx1V6mWKOdEHvOihDeSejCDlLCKPF2YT4IiJoXzbOQ4EvNWHIIopFgAhIrUnSYvqO1pNJ0r02k0FRSqpZlvdrzvKebAl4sFq/QWo+HYej3q5OAR1zMjBVzuXSaGJ0EBqGOLN/hHiReqiyKpMnPdiShlXuj7UrNWBgRIGW1LVIMQ7I7hr7BtHIMFfn82iRGK6/ryj21cOyBZDL5hkY7R0976fzy/PPPJ4eGhu5PJpOv7bW3Xi/pEAvCSUKEfDCZMsAnmSH1XKKHuklFJ/4nDBoFqhnT1mff5G/ZK44E824+MB/MSJv4FbybvqJ56LsslmSWrl8OWj2X1Co53Z5Opz87FwedUcUpm81+zPO8T/bDjteDLilPWX4rmTDZsou9hPDi0cuEDASX0l6AX1uH3bTOKu+PgitVoaQocLSmO+2TNELTAHbtZKEq0ACM5NM/YYquiGwbjdTem7csa5PrupMtA6613pjL5caVUslmEtJGf1q+VdQgxJV94FI2i+8AAWBggmjNNJhA7H79ClVeLmOR78RUSMckI4eaBlzeCdPLRyo38T3vgSlgPmFCKSHe8kC7fGNtwuQffN/n9IrYQgDyyvpKjIlcLvdD13V7mmZtNl4BBsJj26VslkivhGsQn3v5KTXcovVV5buq7XppYcAZH6kYIVUjouXCAZf7o7XhYDIkWuq4RZmp2Zh69T3jcl1X53K5PxsYGPhys/fMqrWaz+ffY1nWN8rlctNzSZs13un3IokQn4+obySudp726cqMUTAFrGbvF4aR90hoA9MgNWgTfqJR5HhoUdsLoQHjxgNDBkFw3Pf9YaXUSyfRznHNAnVmZoZ5ywnbtl/Z6+nSZp2r/16Aiapgfo9KvkhpdOJE5vmjqlxMgGgECAeoUtYjygzRttrtc6/vhxkLhcJdvu+3dDJCo3rpn7Ft+/ZG3nq/Q45mRIva7fnE6VFpXSyS22zMfF9jSpy1Gx3H+Xkrz8QCXiwW1wdBMGaa5qwiu0gLEtXvM0xaGUw79yw2pm2n73IvJqdQKNzn+/6bWj24rqGd5nA6x3E+EJVyiCTF5EmFdnNeeT4DjntG1K84ZPwdtelRVS3HMNd77d3qSy/bqfkbJa31LZ7n/bDVdzUEfGZmZqNlWexcWBa1geS/ySwx4bFYDnqXcEpqt8mpS+LsCRNEnTPx4KV4r4R50Xx+q0RciPtqVR5+nEql3qyUKrfahzk98Ww2+xXP8z5UKBSq9+EQMXWJ1JM+7MZ+51Y7GncfgJIMIeNF6CabKQRMCddEqmlDpD2qASRDB/iEXEzm8HMxajCx3ZZlFTgbNp1O/6gdGs4J+NTU1GrXdR8wTXM1BIK4TGtCIGw467QWonqwmBbWyJGkoT+oZ6QUoPiJBEgoFVXZUQ8fXyRafJ/fYRqAJqVKTn8hCuU2AzCZTOpCoXB3Mpl8V6u2W9psGmtns9n3u6771SAIbAjM7BYE4cNS4IVw3shjM4sGYFK6WiY25suAAI2WILVL+1Ich+XHi8V0AVotq/eCaZqvd1338WbMMSu0nStG3759uzUwMJBYu3bttkQicYMU1ZPkg2y4j6Y1ex3WsIccsNE4TLDQh1a2BrdDGNK6chw2BGZSBDW/GFS853lhPp//t+l0+j+1M6Y5JXz79u3eeeedd142m90chuENiURii2mal0rpS3kYYqA2kTJUae1A8462C8UNApUMwMyo8eH3uJUy8yFAo2ekooJsf0LFM8fdj7XljfpUc9TGU6nUjUqpl07wbfOapdK3bds2uGzZso9alvUO0zQvqaXuYtdx10sz4CN1LMttVo+0nX5Gi+jzHGaEhYNxpbLaabfZvYSgLDWWxReMD2mXRRq91mbR/tUcz2wQBLek0+n7mvW90fezAJ+cnFxaKpXeqbXms97zvAT2OwxDk0/cIPkfHQIA7B3qr1uA40ixmgT7iqTjZbMwMLpzRSY/6k9PlEHL2SX8TW68vqBQ/aRKtO9xS6eZpwf46BTqfAFo9TnP84JCofBp3/f/favPxGrLRg+PjY0lbdse0VqPGoYxrLVeo5Rie+TpwuYysSAxLCpdnKZucD8eOGCjXmtHPFSJzN60qHRzD86WeOjyUxZOsMUJ20+fAIqkEb8LI/Aeqb0OU0XLghKZsOSYC+2Ffec5VDxr1nqtZXgvs2HlcnlbJpP5g3PPPXemJ4BHG+UAuyeffDIxNTX1Zcdx3ie2HMJJRUWRvk46E30W2ynr3WTVCX+jTgEkmjNn2TPfSfiFtpGECoAAtsToMCdtyLHY9YfSynFYwrhoFA7RQdNgRtAmOK/QgLY5H6WVnarzpQvaKAzDJ0ul0ptaPV90rnc1DcuiD+/YsePf+b7/KSl31YsNcoAmZbUACRNBvA9o5ADwD+r3YSPhqN6oFy0aRsxNdBxxs2d8z70wBNuZo22xIRAGJAwlNkfKAR3NgJaT0G2+oDZ6rma3c+Vy+V0DAwMNzzFp573tAv42z/P+Zy1GDWsb5GLtejudkHsBm6wZ0grYSCLvgKiysR41Slo3epEfgBniZsoki1ansRreS4iHyYi2JXvE8B1k6TFMz7YpGAFtAOjd3A7M+x3HKQVB8FfJZPJT86FnWzY87uZdu3aNhGH4U8dxkpVK5Yn169ef8DxvtFQqmZ12qF6yCbsgsDhYcwGO/SblKyCJVKPWa7spqwzE/2XFCrY5WqdUJBwTheqOAs4+ct5Rv82Z5wEdJkUao+eYdkoP13XLhULhS9u2bbv91ltvpRpyV662JPyhhx5aUSqV9vi+fwtC/BUAAAkRSURBVEE2m71ndHT047lc7ruJROLyUqnUVlvR3kNc2ZgAMEgKxI16y1LREJWKKYleqFj2pNGO5MMxBWgI7KwUrOMZ2mYOABssZ6igmmXtXFzpDna1YmZ4LyYlemHT0S4wBO8XSe8EHTzyfD7/N77v/7FSqtBJW/XPtg3SxMTEA6lU6nWZTObj11133SepIKGUonznRfMBHSKhHgEFEAjpsJX1YR1qGykGMJy26CWShp2XI6WjEioeOc+gfuszZgAuR0ljQuq3D+G04eThoMEs9aYD0Ok/W6REvbd7JJeMx3XdSrFY/GEqlSJP3vR46HaZoW3Ad+7c+XHf9z+Rz+dfNzIy8jNemMlkbrAs61uO46xqR71DOCQLCYGgcZsLaR+CEhohkXjEFAWqz5mjoqlNLo5VO4SgfUCl7XqHEI3Dd/STd8IQcvx0nKSTCYRZSfk2O62pXsuhxkul0v2VSuW96XR61vEV7Yyp0b1tAz4xMXG91poTc357dHT0hDScy+VGlVL/zbZt1HtLNh3Jk2MbsK2ozLgQh/l3KilwYdMBvL4oEGHTww8/XE3IEC62c8U9K0uSybZhLmRalfdTcTEufy/Tx9h0+oe2aWVyCcb3PK9ULBZxiP/VkiVLXmyn/+3c2zbgDz/8sF8oFLaMjo7OWmVRO/DuTsdxRorFotWsI0gDEyEQEcmMO8kPpqivw0r1iHrpgdiET3JCQbN3R7/HPmOno9qB9pBUzAReOuEapgAGQF2jCeJm5jBLMCc+CRqL/XJzzeABtuu6xVwud2c6nb49rhBPO2Npdm/bgDdrMJ/Pr1JK3cmES6FQcOIybgwSFY4qh7DYRexj3AXhAFxsLwStT63Kc6h97PE111zT1swWcTwreWAkQEKapQw1GogPCz5w2Mja4TPEFfGRfkgOHjNAZq9RocDaAo18uVz+bCqV+mQ7K1ea4dA1ld7Ki7TW5xQKhTtM03xnGIazDs+BCXBykCwp8NNo6hEgCMmQKqQXxwgCxtVEk434cWXB5uo3DAUDbty4saptJJWLhEv9ODnCgmiBzY9oGN7TqN+SG4BRYdD6kh84Z+Vy+VgYhp9IpVJ3xlVcaoXW7d7TdQmXDmitrVwu9wHTNP/CcZzzRMUj3ThfAF5f9kO0QTSeltIZEBy7SNzbiNi0i2puVKw+jjhIqzhsxN/0AZuO7ZVDamAAGIz3RgvRz3X2Gu1IDXhMlfgVNRVeLpfLE2EYfjSVSnHma9+ungEeceZGlFKfc10Xu55AXUqGiphVCIEqhpgQGWClvtrk5GRVhWJfYRA56A7pqnfwUMPcz7P1oVsjiuJgIcWSRZN4HMBhIBhOfAx+AqQsBMEMxR0sL++KFvaBYQYHBzVxdRAE/yMIgr8cGBjgpKG+Xj0HnNFkMpkVHKRjWdYf5vP5gf3791e9eClkHz3gRkaPF4walyVVePCoWOJl1G+jMtkwBI5W3MlJcZSVQ/FgIBiFvshJw2JOkFCpOIWEEjVg1yUNO5dTBsPQn5UrV4YrV648UCqV7hgYGPhm3DGR/UC+L4DLQMrl8m8fOnTo80ePHr0S9YhKxAYiVRAe6Za/Uav8jkYACADmbxgAO44DVZ9x4z2AAVO0otbRHHj2AAzg/I2WQLp512OPPVb1tjEn+A30RXIHMBb3E6LNlWShr5gv27afWbdu3U0DAwNtr0PrJiP0FXA6vnPnzrsSicS7SWFG1WHUm0e1S5lO/g+4qE9+x9GDgIASd3QUIJCAkXg9bkJFCIjkIYGSI5cqFLX9WmeUzYxu9KdNpJ90alxVyShA9JexBEEweeTIkd+4+eabM90EsN22FgLw/+U4zu+RIMGGN7qQVKQIkKOn+ok2ANhGThMMQXyPyYiL7Xkn7UoYh3RjLmgbRiEaiJbNFP8h6lRGj8UmJm8k5eQasPnlcvmhQqFww5YtWzpawNAuwPX39x3wiYmJL9u2/ScAUT/NGe0cYY2ccya5dZnqBFCcrajTF31WzvyUonlxRJLarrICRub4cRixySRPJATkPfX5BKRcVtqQlEG1R9ewcz9MiXmpVab4+sjISMNyWp0C2erzfQd8x44db3Nd9242P0KkuFQqdhT7iYpFEwBKVLpQxUhNo7w6g4dZYBq0QL304SsQMiGlaAEkWjYgoM6RdMwCQMGU+BtxgHPf4cOHg0wmY7muq2TZtuyIQcsUCgWttSYvftO11167p1VgenVf3wHfs2fPULFYZJ37Jtu2Fepa8tKyTAoJBizf94u1FKYTBEF1oUWrThMSS0wusb6sPaMNHD+8bCQX30A2TIp3LtoFiY1T547jVMiKlcvlk1NTU7947rnnNjqOs6ZSqdgSugVBoG3bDoIg4Czv20ZGRv53r0Bsp92+A07nJiYmrlVK3W1Z1uowDC0cH1kbh/Sirg3DKCSTyc+sXbtWscsiCIKrXNe1lVJ2uVy2nn32WYWdb5R1owE53hIJxUEU24zDhXZAw8iKV+6HKWAoyd3TNkxhmmZoWVYlDEMAnA7D8EGl1I9N0/x7z/P2j42NAfjHwjB8vWVZSbJmlUqFQdyvtf7C6Ojow+2A0st7FwRwBjQ+Pn61ZVmfVkr9FquHUfG1gYZa62ylUvmPo6Ojn+F/L7744hLP8y4Lw3CLUmqzZVmXnTp16sJDhw4hUdaGDRtgitjJGkm3SoUHwj3AlhMTpBCh1GOrzY2zwiRcu3ZtYJpmSSm1X2u9V2u9PQzDHQMDA0/V7+m69957rYsvvni91nq1ZVklx3H2X3311Qd6Cd582l4wwOns7t27U5VKhc3stxiGsVprbVqW9XQYhneNjIw03BWptb4wk8msPnjw4I35fP7SVatWnb98+XIWui2pVYi2Se0qpWAihcY4fvy4wk5jPoirHcfR+XxeI72maVYcx6H6kT548ODUCy+88JTnec9eeumlPzFNc0+hUDjYyynL+QA332cWFPBop/ft2zcwMzNjcgJuu4PRWicNwzi/XC6nHccZCMPwGsMw1oZheKFlWUuUUpxd7VQqFRiKeuKVQqFQDMMQtXtMKfV4MpncUy6XZw4fPnyqVCodalSNuN2+Lbb7Fw3gi40wL9f+/H+ofiMF3u/Y/QAAAABJRU5ErkJggg==';
var propTypes = {
  data: PropTypes.array,
  expandIconAsCell: PropTypes.bool,
  defaultExpandAllRows: PropTypes.bool,
  expandedRowKeys: PropTypes.array,
  defaultExpandedRowKeys: PropTypes.array,
  useFixedHeader: PropTypes.bool,
  columns: PropTypes.array,
  clsPrefix: PropTypes.string,
  bodyStyle: PropTypes.object,
  style: PropTypes.object,
  //特殊的渲染规则的key值
  rowKey: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  rowClassName: PropTypes.func,
  //column的主键，和 column.key 作用相同
  columnKey: PropTypes.string,
  expandedRowClassName: PropTypes.func,
  childrenColumnName: PropTypes.string,
  onExpand: PropTypes.func,
  onRowHover: PropTypes.func,
  onExpandedRowsChange: PropTypes.func,
  indentSize: PropTypes.number,
  onRowClick: PropTypes.func,
  onRowDoubleClick: PropTypes.func,
  expandIconColumnIndex: PropTypes.number,
  //是否显示表头
  showHeader: PropTypes.bool,
  title: PropTypes.func,
  footer: PropTypes.func,
  emptyText: PropTypes.func,
  scroll: PropTypes.object,
  rowRef: PropTypes.func,
  getBodyWrapper: PropTypes.func,
  children: PropTypes.node,
  draggable: PropTypes.bool,
  minColumnWidth: PropTypes.number,
  filterable: PropTypes.bool,
  filterDelay: PropTypes.number,
  onFilterChange: PropTypes.func,
  onFilterClear: PropTypes.func,
  syncHover: PropTypes.bool,
  tabIndex: PropTypes.string,
  hoverContent: PropTypes.func,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  rowDraggAble: PropTypes.bool,
  hideDragHandle: PropTypes.bool,
  // 隐藏行拖拽把手
  onDropRow: PropTypes.func,
  onDragRowStart: PropTypes.func,
  onBodyScroll: PropTypes.func,
  bodyDisplayInRow: PropTypes.bool,
  // 表格内容超出列宽度时进行换行 or 以...形式展现
  headerDisplayInRow: PropTypes.bool,
  // 表头内容超出列宽度时进行换行 or 以...形式展现
  showRowNum: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  // 表格是否自动生成序号,格式为{base:number || 0,defaultKey:string || '_index',defaultName:string || '序号'}
  onPaste: PropTypes.func,
  onBodyMouseLeave: PropTypes.func
};
var defaultProps = {
  data: [],
  useFixedHeader: false,
  expandIconAsCell: false,
  defaultExpandAllRows: false,
  defaultExpandedRowKeys: [],
  columnKey: 'key',
  rowKey: 'key',
  rowClassName: function rowClassName() {
    return '';
  },
  expandedRowClassName: function expandedRowClassName() {
    return '';
  },
  onExpand: function onExpand() {},
  onExpandedRowsChange: function onExpandedRowsChange() {},
  onRowClick: function onRowClick() {},
  // onRowDoubleClick() { },
  clsPrefix: 'u-table',
  bodyStyle: {},
  style: {},
  childrenColumnName: 'children',
  indentSize: 15,
  expandIconColumnIndex: 0,
  showHeader: true,
  scroll: {},
  rowRef: function rowRef() {
    return null;
  },
  getBodyWrapper: function getBodyWrapper(body) {
    return body;
  },
  // emptyText: () => <div><Icon type="uf-nodata" className="table-nodata"></Icon><span>{locale["no_data"]}</span></div>,
  columns: [],
  minColumnWidth: 80,
  locale: {},
  syncHover: true,
  // setRowHeight:()=>{},
  setRowParentIndex: function setRowParentIndex() {},
  tabIndex: '0',
  heightConsistent: false,
  syncFixedRowHeight: false,
  size: 'md',
  rowDraggAble: false,
  hideDragHandle: false,
  onDropRow: function onDropRow() {},
  onDragRowStart: function onDragRowStart() {},
  onBodyScroll: function onBodyScroll() {},
  bodyDisplayInRow: true,
  headerDisplayInRow: true,
  showRowNum: false,
  onPaste: function onPaste() {},
  originWidth: null //做什么用??

};
var expandIconCellWidth = Number(43);
var Table = (_dec = WebUI({
  name: "table",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(Table, _Component);

  var _super = _createSuper(Table);

  function Table(props) {
    var _this;

    _classCallCheck(this, Table);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "resize", function () {
      var debounceFunc = function debounceFunc() {
        _this.syncFixedTableRowHeight();

        _this.computeTableWidth();

        typeof _this.props.onResize == 'function' && _this.props.onResize();
      };

      debounce(debounceFunc(), 150);
      var renderFlag = _this.state.renderFlag;

      _this.setState({
        renderFlag: !renderFlag
      });
    });

    _defineProperty(_assertThisInitialized(_this), "syncFixedTableScrollWidth", function () {
      var clsPrefix = _this.props.clsPrefix;
      var tableDom = _this.contentTable;
      var tableContentDom = tableDom.querySelector(".".concat(clsPrefix, "-content"));
      var tableFixedRight = tableDom.querySelector(".".concat(clsPrefix, "-fixed-right"));
      var centerBodyDom = tableDom.querySelector(".".concat(clsPrefix, "-scroll .").concat(clsPrefix, "-body"));
      var centerHeadDom = tableDom.querySelector(".".concat(clsPrefix, "-scroll .").concat(clsPrefix, "-header")); //固定列头的情况下

      if (!centerHeadDom) centerHeadDom = tableDom.querySelector(".".concat(clsPrefix, "-scroll .").concat(clsPrefix, "-thead")); //未固定列头的情况下
      //注意精准匹配，以确保行展开表格嵌套表格时正确匹配

      var centerHeadTableDom = tableDom.querySelector(".".concat(clsPrefix, "-scroll .").concat(clsPrefix, "-header > table[data-for-table='").concat(_this.tableUid, "']"));
      var centerBodyTableDom = tableDom.querySelector(".".concat(clsPrefix, "-scroll .").concat(clsPrefix, "-body > table[data-for-table='").concat(_this.tableUid, "']"));
      var bodyInnerDoms = tableDom.querySelectorAll(".".concat(clsPrefix, "-body-outer .").concat(clsPrefix, "-body-inner")); // if(!this.scrollbarWidth)this.scrollbarWidth=measureScrollbar();

      var scrollbarWidth = _this.scrollbarWidth;
      var hasCenterScrollY = centerBodyTableDom.getBoundingClientRect().height > centerBodyDom.getBoundingClientRect().height ? true : false; //中间区域是否存在垂直滚动条

      var hasCenterScrollX = centerBodyTableDom.getBoundingClientRect().width > centerBodyDom.getBoundingClientRect().width ? true : false; //中间区域存在水平滚动条
      // console.log("AAA---->syncFixedTableScrollWidth-->hasCenterScrollX"+hasCenterScrollX+"-->hasCenterScrollY"+hasCenterScrollY)
      //解决存在右侧固定列,中间区域垂直滚动条需要隐藏显示的问题

      if (hasCenterScrollY && _this.columnManager.isAnyColumnsRightFixed()) {
        //非Chrome内核浏览器中间区域会出现多余垂直滚动条需要隐藏
        centerBodyDom.style.marginRight = browserInfo.browserType == 'Chrome' ? 0 : "-".concat(scrollbarWidth, "px");
      } else {
        centerBodyDom.style.marginRight = 0;
      }

      if (centerHeadDom) centerHeadDom.style.marginRight = centerBodyDom.style.marginRight; //解决中间区域存在水平滚动条，左右固定区域无法跟其对齐的问题

      if (bodyInnerDoms && bodyInnerDoms.length) {
        [].forEach.call(bodyInnerDoms, function (bodyInnerDom) {
          if (hasCenterScrollX) {
            bodyInnerDom.style.overflowX = 'scroll'; //确保中间x滚动出现时，左右固定列x滚动条正确显示占位
            // bodyInnerDom.style.paddingBottom = browserInfo.browserType=='Chrome'?0:`${scrollbarWidth}px`;//chrome下左右固定列底部不需要填充占位,firefox需要占位，

            bodyInnerDom.style.paddingBottom = 0; //firefox升级89.0.2后不需要占位了
          } else {
            bodyInnerDom.style.overflowX = 'hidden'; //确保中间x滚动不出现时，左右固定列x滚动条不显示

            bodyInnerDom.style.paddingBottom = 0;
          }
        });
      } //解决中间存在水平滚动条头部区域无法对齐的问题


      if (centerHeadTableDom) {
        var paddingWidth = 0;
        if (hasCenterScrollY && hasCenterScrollX || hasCenterScrollY && !tableFixedRight) paddingWidth = paddingWidth + scrollbarWidth;
        centerHeadTableDom.style.paddingRight = "".concat(paddingWidth, "px");
      } //为表格追加是否存在滚动条的样式标识


      if (tableContentDom) {
        if (hasCenterScrollX) {
          if (!tableContentDom.classList.contains('has-scroll-x')) tableContentDom.classList.add('has-scroll-x');
        } else {
          tableContentDom.classList.remove('has-scroll-x');
        }

        if (hasCenterScrollY) {
          if (_this.headTable) _this.headTable.style.overflowY = 'scroll'; //中间区域有垂直滚动条，则头部也需要显示头部滚动条

          if (!tableContentDom.classList.contains('has-scroll-y')) tableContentDom.classList.add('has-scroll-y');
        } else {
          if (_this.headTable) _this.headTable.style.overflowY = 'hidden'; //中间区域无垂直滚动条，则头部也不需要显示头部滚动条

          tableContentDom.classList.remove('has-scroll-y');
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDragBorderMouseDown", function (event) {
      var minColumnWidth = _this.props.minColumnWidth;
      var dragGapDom = Event.getTarget(event);
      var currentDom = dragGapDom.parentElement;
      var columnKey = currentDom.getAttribute('data-col-key');
      var columnFixed = currentDom.getAttribute('data-th-fixed');
      var columnWidth = currentDom.getAttribute('data-th-width');
      var columnIndex = currentDom.getAttribute('data-col-index');
      var currentInfo = {
        columnKey: columnKey,
        columnFixed: columnFixed,
        columnWidth: columnWidth,
        columnIndex: columnIndex
      };

      var tableRect = _this.contentTable.getBoundingClientRect(); //表格


      var dragGapRect = dragGapDom.getBoundingClientRect(); //当前的伸缩label
      //向上查找th元素

      function getParentThElement(element) {
        var _tagName = element.tagName.toLowerCase();

        if (element.getAttribute('data-filter-type') === 'filterContext') return null;
        if (_tagName === 'i') return null;

        if (_tagName != 'th') {
          return getParentThElement(element.parentElement);
        } else {
          return element;
        }
      }

      var thDom = getParentThElement(currentDom);
      var resizerDefaultWidth = thDom.getBoundingClientRect().width;
      var resizerLineHeight = tableRect.height;
      var resizerLineLeft = dragGapRect.right - tableRect.left - parseInt(dragGapRect.width / 2) - 1;

      var column = _this.columnManager.leafColumns().find(function (col) {
        return col.key ? col.key == columnKey : col.dataIndex == columnKey;
      });

      _this.setState({
        resizerVisible: true,
        resizerLineHeight: resizerLineHeight,
        resizerLineLeft: resizerLineLeft,
        resizerDefaultWidth: resizerDefaultWidth,
        resizerMinWidth: column.minWidth || minColumnWidth,
        dataSource: currentInfo
      });

      _this.resizerLine.start(event);
    });

    _defineProperty(_assertThisInitialized(_this), "onDragBorderMouseUp", function (event, moveX, info) {
      var _this$props = _this.props,
          minColumnWidth = _this$props.minColumnWidth,
          onDropBorder = _this$props.onDropBorder;
      var target = Event.getTarget(event);
      var columnKey = info.columnKey,
          columnFixed = info.columnFixed,
          columnWidth = info.columnWidth,
          columnIndex = info.columnIndex;

      var column = _this.columnManager.leafColumns().find(function (col) {
        return col.key ? col.key == columnKey : col.dataIndex == columnKey;
      });

      var oldWidth = ColumnManager.DefaultColumnWidth; //原宽度

      if (typeof column.width == 'string' && column.width.indexOf('%') > -1) {
        //百分比情况
        oldWidth = parseInt(columnWidth);
      } else if (column.width) {
        //非百分比情况
        oldWidth = parseInt(column.width);
      }

      var newWidth = oldWidth + moveX; //拖动后的宽度

      newWidth = newWidth < minColumnWidth ? minColumnWidth : newWidth; //限制最小宽度

      _this.columnManager.clearCache(); //注意：先清除缓存


      var changeColumn = _this.columnManager.findColumn(column.key || column.dataIndex);

      if (!changeColumn) {
        console.error('拖拽列宽度未找到列定义：' + (column.key || column.dataIndex), column);
        return;
      }

      changeColumn.width = newWidth;

      _this.computeTableWidth(); //注意：重新计算需要补充的列宽度
      // let newWidthDiff = newWidth-oldWidth;//计算新旧宽度的实际变化距离, 负数为缩小，正数为放大
      // console.log("AAA---onDragBorderMouseUp-->最终距离"+moveX+'---表宽度--'+this.contentWidth+'---实际变化距离---'+newWidthDiff,this.columnManager.columns)


      _this.setState({
        resizerVisible: false
      });

      typeof onDropBorder == 'function' && onDropBorder(event, newWidth, column, _this.columnManager.columns);
    });

    _defineProperty(_assertThisInitialized(_this), "onDragBorderCancel", function (event, moveX, info) {
      _this.setState({
        resizerVisible: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onDragBorderMouseMove", function (event, moveX, info) {
      var _this$props2 = _this.props,
          minColumnWidth = _this$props2.minColumnWidth,
          onDraggingBorder = _this$props2.onDraggingBorder;
      var columnKey = info.columnKey,
          columnFixed = info.columnFixed,
          columnWidth = info.columnWidth,
          columnIndex = info.columnIndex;

      var column = _this.columnManager.leafColumns().find(function (col) {
        return col.key ? col.key == columnKey : col.dataIndex == columnKey;
      });

      var oldWidth = ColumnManager.DefaultColumnWidth; //原宽度
      //原宽度

      if (typeof column.width == 'string' && column.width.indexOf('%') > -1) {
        //百分比情况
        oldWidth = parseInt(columnWidth);
      } else if (column.width) {
        //非百分比情况
        oldWidth = parseInt(column.width);
      }

      var newWidth = oldWidth + moveX; //拖动后的宽度

      newWidth = newWidth < minColumnWidth ? minColumnWidth : newWidth; //限制最小宽度

      typeof onDraggingBorder == 'function' && onDraggingBorder(event, newWidth, column, _this.columnManager.columns); // console.log("AAA---onDragBorderMouseMove-->移动距离"+moveX)
    });

    _defineProperty(_assertThisInitialized(_this), "onDragRowStart", function (currentKey) {
      var data = _this.state.data,
          currentIndex,
          record;
      data.forEach(function (da, i) {
        // tr 的唯一标识通过 data.key 或 rowKey 两种方式传进来
        var trKey = da.key ? da.key : _this.getRowKey(da, i);

        if (trKey == currentKey) {
          currentIndex = i;
          record = da;
        }
      });
      _this.props.onDragRowStart && _this.props.onDragRowStart(record, currentIndex);
    });

    _defineProperty(_assertThisInitialized(_this), "onDragRow", function (currentKey, targetKey) {
      var data = _this.state.data,
          currentIndex,
          targetIndex,
          record;
      data.forEach(function (da, i) {
        // tr 的唯一标识通过 data.key 或 rowKey 两种方式传进来
        var trKey = da.key ? da.key : _this.getRowKey(da, i);

        if (trKey == currentKey) {
          currentIndex = i;
          record = da;
        }

        if (trKey == targetKey) {
          targetIndex = i;
        }
      });

      if (currentIndex > -1) {
        if (_this.contentTable.dragType == 'top') {
          targetIndex = targetIndex - 1;
        }

        data = _this.swapArray(data, currentIndex, targetIndex);
        _this.props.onDropRow && _this.props.onDropRow(data, record, targetIndex);

        _this.setState({
          data: data
        });
      } else {
        _this.props.onDropRow && _this.props.onDropRow(data, record, targetIndex);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "swapArray", function (arr, index1, index2) {
      var value1 = arr[index1];
      arr.splice(index1, 1);

      if (index1 < index2) {
        arr.splice(index2, 0, value1);
      } else {
        arr.splice(index2 + 1, 0, value1);
      }

      return arr;
    });

    _defineProperty(_assertThisInitialized(_this), "clearBodyMouseLeaveTimer", function () {
      if (_this.bodyMouseLeaveTimmer) {
        clearTimeout(_this.bodyMouseLeaveTimmer);
        _this.bodyMouseLeaveTimmer = null;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onRowHoverMouseEnter", function () {
      _this.store.setState({
        currentHoverKey: _this.currentHoverKey
      });

      if (_this.hoverDom) _this.hoverDom.style.display = 'block';

      _this.clearBodyMouseLeaveTimer();
    });

    _defineProperty(_assertThisInitialized(_this), "onRowHoverMouseLeave", function () {});

    _defineProperty(_assertThisInitialized(_this), "onTableHoverMouseLeave", function () {
      _this.hideHoverDom();
    });

    _defineProperty(_assertThisInitialized(_this), "onFocus", function (e) {
      _this.props.onKeyTab && _this.props.onKeyTab();
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (e) {
      var event = Event.getEvent(e); // event.preventDefault?event.preventDefault():event.returnValue = false;

      if (event.keyCode === 38) {
        //up
        event.preventDefault && event.preventDefault();
        _this.props.onKeyUp && _this.props.onKeyUp();
      } else if (event.keyCode === 40) {
        //down
        event.preventDefault && event.preventDefault();
        _this.props.onKeyDown && _this.props.onKeyDown();
      }

      _this.props.onTableKeyDown && _this.props.onTableKeyDown();
    });

    var expandedRowKeys = [];

    var rows = _toConsumableArray(props.data);

    var showDragHandle = !props.hideDragHandle && props.rowDraggAble;
    _this.columnManager = new ColumnManager(props.columns, props.children, props.originWidth, showDragHandle, props.showRowNum); // 加入props.showRowNum参数

    _this.store = createStore({
      currentHoverKey: null
    });
    _this.firstDid = true;
    _this.scrollYChanged = false;

    if (props.defaultExpandAllRows) {
      for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        expandedRowKeys.push(_this.getRowKey(row, i));
        rows = rows.concat(row[props.childrenColumnName] || []);
      }
    } else {
      expandedRowKeys = props.expandedRowKeys || props.defaultExpandedRowKeys;
    }

    _this.state = {
      expandedRowKeys: expandedRowKeys,
      data: props.data,
      currentHoverKey: null,
      scrollPosition: 'left',
      fixedColumnsHeadRowsHeight: [],
      fixedColumnsBodyRowsHeight: [],
      fixedColumnsExpandedRowsHeight: {} //扩展行的高度

    };
    _this.onExpandedRowsChange = _this.onExpandedRowsChange.bind(_assertThisInitialized(_this));
    _this.onExpanded = _this.onExpanded.bind(_assertThisInitialized(_this));
    _this.onRowDestroy = _this.onRowDestroy.bind(_assertThisInitialized(_this));
    _this.getRowKey = _this.getRowKey.bind(_assertThisInitialized(_this));
    _this.getExpandedRows = _this.getExpandedRows.bind(_assertThisInitialized(_this));
    _this.getHeader = _this.getHeader.bind(_assertThisInitialized(_this));
    _this.getHeaderRows = _this.getHeaderRows.bind(_assertThisInitialized(_this));
    _this.getExpandedRow = _this.getExpandedRow.bind(_assertThisInitialized(_this));
    _this.getRowsByData = _this.getRowsByData.bind(_assertThisInitialized(_this));
    _this.getRows = _this.getRows.bind(_assertThisInitialized(_this));
    _this.getColGroup = _this.getColGroup.bind(_assertThisInitialized(_this));
    _this.getLeftFixedTable = _this.getLeftFixedTable.bind(_assertThisInitialized(_this));
    _this.getRightFixedTable = _this.getRightFixedTable.bind(_assertThisInitialized(_this));
    _this.getTable = _this.getTable.bind(_assertThisInitialized(_this));
    _this.getTitle = _this.getTitle.bind(_assertThisInitialized(_this));
    _this.getFooter = _this.getFooter.bind(_assertThisInitialized(_this));
    _this.getEmptyText = _this.getEmptyText.bind(_assertThisInitialized(_this));
    _this.getHeaderRowStyle = _this.getHeaderRowStyle.bind(_assertThisInitialized(_this));
    _this.syncFixedTableRowHeight = _this.syncFixedTableRowHeight.bind(_assertThisInitialized(_this));
    _this.resetScrollX = _this.resetScrollX.bind(_assertThisInitialized(_this));
    _this.findExpandedRow = _this.findExpandedRow.bind(_assertThisInitialized(_this));
    _this.isRowExpanded = _this.isRowExpanded.bind(_assertThisInitialized(_this)); // this.detectScrollTarget = this.detectScrollTarget.bind(this);

    _this.handleBodyScroll = _this.handleBodyScroll.bind(_assertThisInitialized(_this));
    _this.handleRowHover = _this.handleRowHover.bind(_assertThisInitialized(_this));
    _this.computeTableWidth = _this.computeTableWidth.bind(_assertThisInitialized(_this));
    _this.onBodyMouseLeave = _this.onBodyMouseLeave.bind(_assertThisInitialized(_this));
    _this.tableUid = "_table_uid_" + new Date().getTime();
    _this.contentTable = null;
    _this.leftColumnsLength; //左侧固定列的长度
    // this.centerColumnsLength  //非固定列的长度// this.columnsChildrenList = [];//复杂表头、所有叶子节点

    _this.dataChanged = false; // 数据是否改变
    //同步行高时使用的缓存

    _this.fixedColumnsHeadRowsHeightCache = null;
    _this.fixedColumnsBodyRowsHeightCache = null;
    _this.fixedColumnsExpandedRowsHeightCache = null;
    return _this;
  }

  _createClass(Table, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.centerColumnsLength = this.columnManager.centerColumns().length;
      this.leftColumnsLength = this.columnManager.leftColumns().length;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // this.getTableUID();
      EventUtil.addHandler(this.contentTable, 'keydown', this.onKeyDown);
      EventUtil.addHandler(this.contentTable, 'focus', this.onFocus);
      setTimeout(this.resetScrollX, 300); //含有纵向滚动条
      // if(this.props.scroll.y){
      //    this.scrollbarWidth = measureScrollbar(`.u-table`);
      // }

      this.scrollbarWidth = measureScrollbar(); //dom装载后获取浏览器下的滚动条宽度
      //后续也放在recevice里面

      if (!this.props.originWidth) {
        this.computeTableWidth();
      }

      var _this$props3 = this.props,
          useFixedHeader = _this$props3.useFixedHeader,
          _this$props3$scroll = _this$props3.scroll,
          scroll = _this$props3$scroll === void 0 ? {} : _this$props3$scroll;

      if (this.columnManager.isAnyColumnsFixed()) {
        this.syncFixedTableRowHeight(); //同步固定列的内容行高度

        var targetNode = this.contentTable;

        if (targetNode) {
          this.resizeObserver = new ResizeObserver(function () {
            _this2.resize();
          });
          this.resizeObserver.observe(targetNode);
        }
      }

      if (scroll.y) {
        //固定列头存在则执行head和body的宽度
        this.syncFixedTableScrollWidth(); //同步固定列的滚动宽度
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this$props4 = this.props,
          hideDragHandle = _this$props4.hideDragHandle,
          rowDraggAble = _this$props4.rowDraggAble,
          showRowNum = _this$props4.showRowNum,
          clsPrefix = _this$props4.clsPrefix; // 清除同步行高时使用的缓存

      this.fixedColumnsHeadRowsHeightCache = null;
      this.fixedColumnsBodyRowsHeightCache = null;
      this.fixedColumnsExpandedRowsHeightCache = null;

      if ('data' in nextProps) {
        this.setState({
          data: nextProps.data
        });
      }

      if ('expandedRowKeys' in nextProps) {
        this.setState({
          expandedRowKeys: nextProps.expandedRowKeys
        });
      }

      if (nextProps.columns && nextProps.columns !== this.props.columns) {
        this.columnManager.reset(nextProps.columns, null, showRowNum, !hideDragHandle && rowDraggAble); // 加入this.props.showRowNum参数

        if (nextProps.columns.length !== this.props.columns.length && this.bodyTable) {
          this.scrollTop = this.bodyTable.scrollTop;
        }
      } else if (nextProps.children !== this.props.children) {
        this.columnManager.reset(null, nextProps.children, showRowNum, !hideDragHandle && rowDraggAble); // 加入this.props.showRowNum参数
      } //适配lazyload


      if (nextProps.scrollTop > -1) {
        // this.bodyTable.scrollTop = nextProps.scrollTop;
        this.scrollTop = nextProps.scrollTop;
      } // fix:模态框中使用table，计算的滚动条宽度为0的bug
      // fix:表格首次渲染时 display:none，再显示时，未重新计算，导致表行出现错位的bug
      // if(this.scrollbarWidth<=0 && this.props.scroll.y){
      //   this.scrollbarWidth = measureScrollbar(`.${clsPrefix}`);
      // }


      if (!nextProps.originWidth) {
        this.computeTableWidth();
        this.firstDid = true; //避免重复update
      }

      if (nextProps.resetScroll) {
        this.resetScrollX();
      } // console.log('this.scrollTop**********',this.scrollTop);

    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      // todo: IE 大数据渲染，行高不固定，且设置了 heightConsistent={true} 时，滚动加载操作会导致 ie11 浏览器崩溃
      // https://github.com/tinper-bee/bee-table/commit/bd2092cdbaad236ff89477304e58dea93325bf09
      var _this$props5 = this.props,
          useFixedHeader = _this$props5.useFixedHeader,
          _this$props5$scroll = _this$props5.scroll,
          scroll = _this$props5$scroll === void 0 ? {} : _this$props5$scroll;

      if (this.columnManager.isAnyColumnsFixed()) {
        debounce(this.syncFixedTableRowHeight(), 200); //同步固定列内容行的高度
      }

      if (scroll.y) {
        //固定列头存在则执行head和body的宽度
        debounce(this.syncFixedTableScrollWidth(), 200); //同步固定列的滚动宽度
      } //适应模态框中表格、以及父容器宽度变化的情况


      if (typeof this.props.scroll.x !== 'number' && this.contentTable.getBoundingClientRect().width !== this.contentDomWidth && this.firstDid) {
        this.computeTableWidth();
        this.firstDid = false; //避免重复update
      }

      if (this.scrollTop > -1) {
        this.fixedLeftBodyInner && (this.fixedLeftBodyInner.scrollTop = this.scrollTop);
        this.fixedRightBodyInner && (this.fixedRightBodyInner.scrollTop = this.scrollTop);
        this.bodyTable.scrollTop = this.scrollTop;
        this.scrollTop = -1;
      } // 当表格没有数据时，重置滚动条位置，造成grid里面的表头列无法操作
      // if (prevProps.data.length === 0  || this.props.data.length === 0 ) {
      //   this.resetScrollX();
      // }
      // 当懒加载手动设置的scroll.y发生变化时，滚动条回到顶部


      var prevScrollY = prevProps.scroll.y;
      var currentScrollY = this.props.scroll.y;

      if (prevScrollY && currentScrollY && prevScrollY !== currentScrollY && this.props.lazyLoad && !this.props.ignoreScrollYChange) {
        this.bodyTable.scrollTop = 0;
      } else if (this.props.ignoreScrollYChange && currentScrollY && prevScrollY) {
        if (prevScrollY !== currentScrollY) {
          this.scrollYChanged = true;
          var bodyScrollTop = this.bodyTable.scrollTop;

          if (bodyScrollTop === 0) {
            // 在顶部的时候，滚动条不用动
            this.bodyTable.scrollTop = 0;
          } else {
            var distance = bodyScrollTop + currentScrollY - prevScrollY;

            if (distance < 0) {
              this.bodyTable.scrollTop = 0;
            } else {
              var _this$bodyTable = this.bodyTable,
                  scrollHeight = _this$bodyTable.scrollHeight,
                  scrollTop = _this$bodyTable.scrollTop;
              var bottomDistance = Math.abs(scrollHeight - scrollTop - prevScrollY); // 在最底部的时候也不用滚动滚动条

              if (bottomDistance < 5) {
                // 有些dom计算不是十分精确，设置一个值来缓冲一下
                this.bodyTable.scrollTop = scrollTop + prevScrollY - currentScrollY;
              } else {
                this.bodyTable.scrollTop = distance;
              }
            }
          }
        } else if (this.scrollYChanged) {
          this.bodyTable.scrollTop += 1;
          this.scrollYChanged = false;
        }
      } // 是否传入 scroll中的y属性，如果传入判断是否是整数，如果是则进行比较 。bodyTable 的clientHeight进行判断
      // this.isShowScrollY();
      // gx为了解决底部滚动条显示的问题
      // if (this.bodyTable) {
      //   const currentOverflowX = window.getComputedStyle(this.bodyTable).overflowX;
      //   if (this.props.scroll.x && currentOverflowX !== 'scroll') {
      //     // 此处应该对比一下实际的
      //     if (this.computeWidth > this.contentDomWidth) {
      //       this.bodyTable.style.overflowX = 'scroll';
      //     }
      //   }
      // }
      // let scrollContainerWidth = window.getComputedStyle(this.bodyTableOuter.querySelector('.scroll-container')).width; // scroll-container层元素的宽度
      // let scrollContainerTableWidth =  this.bodyTableOuter.querySelector('.table-bordered').style.width; // scroll-container内层table元素的宽度
      // // 有左右固定列时，scroll-container因为有竖直滚动条，使得scroll-container实际宽度（不包括滚动条的宽度）小于内部table宽度出现水平方向滚动条，导致滚动到底部不对齐
      // if ((parseFloat(scrollContainerWidth) >= parseFloat(scrollContainerTableWidth)) && (this.columnManager.leftLeafColumns().length > 0 || this.columnManager.rightLeafColumns().length > 0)) {
      //   this.bodyTable.style.overflowX = 'hidden';
      // } else {
      //   this.bodyTable.style.overflowX = 'auto';
      // }
      // if (this.bodyTableOuter) { // 隐藏几个不需要真正滚动的父元素的滚动条
      //   this.bodyTableOuter.style.overflowY = 'hidden'
      // }
      // if (this.fixedColumnsBodyLeftOuter) {
      //   this.fixedColumnsBodyLeftOuter.style.overflowY = 'hidden'
      // }
      // if (this.fixedColumnsBodyRightOuter) {
      //   this.fixedColumnsBodyRightOuter.style.overflowY = 'hidden'
      // }

    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // 移除绑定事件,避免内存泄漏
      this.contentTable = null;
      EventUtil.removeHandler(this.contentTable, 'keydown', this.onKeyDown);
      EventUtil.removeHandler(this.contentTable, 'focus', this.onFocus);

      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }
  }, {
    key: "computeTableWidth",
    value:
    /*
    getTableUID =()=>{
      let uid = "_table_uid_"+new Date().getTime();
      this.tableUid = uid;
      let div = document.createElement("div");
      div.className = "u-table-drag-hidden-cont";
      div.id = uid;
      this.contentTable.appendChild(div);
    }
     */
    //计算表格宽度 --- 这块有必要？待确认 待废除 zzj
    function computeTableWidth() {
      var expandIconAsCell = this.props.expandIconAsCell; //如果用户传了scroll.x按用户传的为主

      var setWidthParam = this.props.scroll.x;

      if (typeof setWidthParam == 'number') {
        var numSetWidthParam = parseInt(setWidthParam);
        this.contentWidth = numSetWidthParam;
      } else {
        // this.preContentDomWidth = this.contentDomWidth;
        //计算总表格宽度、根据表格宽度和各列的宽度和比较，重置最后一列
        this.contentDomWidth = this.contentTable.getBoundingClientRect().width; //表格容器宽度

        this.contentWidth = this.contentDomWidth; //默认与容器宽度一样
      }

      var computeObj = this.columnManager.getColumnWidth(this.contentWidth);
      var expandColWidth = expandIconAsCell ? expandIconCellWidth : 0;
      var lastShowIndex = computeObj.lastShowIndex;
      this.computeWidth = computeObj.computeWidth + expandColWidth;
      this.domWidthDiff = this.contentDomWidth - this.computeWidth;

      if (typeof setWidthParam == 'string' && setWidthParam.indexOf('%')) {
        this.contentWidth = this.contentWidth * parseInt(setWidthParam) / 100;
        this.domWidthDiff = this.contentDomWidth - this.contentWidth;
      }

      if (this.computeWidth < this.contentWidth) {
        var contentWidthDiff = this.scrollbarWidth ? this.contentWidth - this.computeWidth - this.scrollbarWidth : this.contentWidth - this.computeWidth; //bordered的表格需要减去边框的差值1

        if (this.props.bordered) {
          contentWidthDiff = contentWidthDiff - 1;
        }

        this.setState({
          contentWidthDiff: contentWidthDiff,
          lastShowIndex: lastShowIndex
        });
      } else {
        this.contentWidth = this.computeWidth;
        this.setState({
          contentWidthDiff: 0,
          lastShowIndex: lastShowIndex
        }); //重新渲染，为了显示滚动条
      }
    } //根据内容动态的判断是否显示纵向滚动条

  }, {
    key: "isShowScrollY",
    value: function isShowScrollY() {
      var props = this.props;
      var y = props.scroll && props.scroll.y;

      if (y) {
        var bodyH = this.bodyTable.clientHeight;
        var bodyContentH = this.bodyTable.querySelector('table').clientHeight;
        var rightBodyTable = this.fixedRightBodyInner; // const leftBodyTable = this.fixedLeftBodyInner;

        var overflowy = bodyContentH <= bodyH ? 'auto' : 'scroll';
        this.bodyTable.style.overflowY = overflowy;
        this.headTable.style.overflowY = overflowy;
        rightBodyTable && (rightBodyTable.style.overflowY = overflowy);
      }
    } //同步固定列情况下部分区域滚动条出现引起的错位问题

  }, {
    key: "onExpandedRowsChange",
    value: function onExpandedRowsChange(expandedRowKeys) {
      if (!this.props.expandedRowKeys) {
        this.setState({
          expandedRowKeys: expandedRowKeys
        });
      }

      this.props.onExpandedRowsChange(expandedRowKeys);
    }
  }, {
    key: "onExpanded",
    value: function onExpanded(expanded, record, index, e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }

      var info = this.findExpandedRow(record);

      if (typeof info !== 'undefined' && !expanded) {
        this.onRowDestroy(record, index, true);
      } else if (!info && expanded) {
        var expandedRows = this.getExpandedRows().concat();
        expandedRows.push(this.getRowKey(record, index));
        this.onExpandedRowsChange(expandedRows);
      }

      this.props.onExpand(expanded, record, index);
    }
  }, {
    key: "onRowDestroy",
    value: function onRowDestroy(record, rowIndex, isExpandOperation) {
      var expandedRows = this.getExpandedRows().concat();
      var rowKey = this.getRowKey(record, rowIndex);
      var index = -1;
      expandedRows.forEach(function (r, i) {
        if (r === rowKey) {
          index = i;
        }
      });

      if (index !== -1) {
        expandedRows.splice(index, 1);
      } //


      if (this.currentHoverKey == rowKey && this.hoverDom) {
        this.hoverDom.style.display = 'none';
      } // todo:如果是TableRow组件卸载触发的该方法，需要加判断，解决懒加载时，持续触发onExpandedRowsChange的问题


      if (isExpandOperation) {
        this.onExpandedRowsChange(expandedRows);
      } else {
        var info = this.findExpandedRow(record);

        if (typeof info === 'undefined') {
          this.onExpandedRowsChange(expandedRows);
        }
      }
    }
  }, {
    key: "getRowKey",
    value: function getRowKey(record, index) {
      var rowKey = this.props.rowKey;
      var key = typeof rowKey === 'function' ? rowKey(record, index) : record[rowKey];
      warningOnce(key !== undefined, 'Each record in table should have a unique `key` prop,' + 'or set `rowKey` to an unique primary key.');
      return key;
    }
  }, {
    key: "getExpandedRows",
    value: function getExpandedRows() {
      return this.props.expandedRowKeys || this.state.expandedRowKeys;
    }
  }, {
    key: "getHeader",
    value: function getHeader(columns, fixed, leftFixedWidth, rightFixedWidth) {
      var _this$props6 = this.props,
          filterDelay = _this$props6.filterDelay,
          onFilterChange = _this$props6.onFilterChange,
          onFilterClear = _this$props6.onFilterClear,
          filterable = _this$props6.filterable,
          showHeader = _this$props6.showHeader,
          expandIconAsCell = _this$props6.expandIconAsCell,
          clsPrefix = _this$props6.clsPrefix,
          onDragStart = _this$props6.onDragStart,
          onDragEnter = _this$props6.onDragEnter,
          onDragOver = _this$props6.onDragOver,
          onDrop = _this$props6.onDrop,
          onDragEnd = _this$props6.onDragEnd,
          draggable = _this$props6.draggable,
          onMouseDown = _this$props6.onMouseDown,
          onMouseMove = _this$props6.onMouseMove,
          onMouseUp = _this$props6.onMouseUp,
          dragborder = _this$props6.dragborder,
          dragborderKey = _this$props6.dragborderKey,
          minColumnWidth = _this$props6.minColumnWidth,
          headerHeight = _this$props6.headerHeight,
          afterDragColWidth = _this$props6.afterDragColWidth,
          headerScroll = _this$props6.headerScroll,
          bordered = _this$props6.bordered,
          onDropBorder = _this$props6.onDropBorder,
          onDraggingBorder = _this$props6.onDraggingBorder,
          bodyDisplayInRow = _this$props6.bodyDisplayInRow,
          headerEventNoStop = _this$props6.headerEventNoStop,
          onCopy = _this$props6.onCopy;
      var columnsChildrenList = []; //复杂表头拖拽，重新render表头前，将其置空

      var rows = this.getHeaderRows({
        columns: columns,
        columnsChildrenList: columnsChildrenList
      });

      if (expandIconAsCell && fixed !== 'right') {
        rows[0].unshift({
          key: "".concat(prefix, "-table-expandIconAsCell"),
          className: "".concat(clsPrefix, "-expand-icon-th"),
          title: '',
          rowSpan: rows.length,
          width: expandIconCellWidth
        });
        columnsChildrenList.unshift({
          className: "".concat(prefix, "-table-expand-icon-column"),
          key: "expand-icon"
        });
      }

      if (fixed) {
        columnsChildrenList = columnsChildrenList.filter(function (col) {
          return col.fixed == fixed;
        }); //只获取对应的固定列
      } else {
        columnsChildrenList = columnsChildrenList.filter(function (col) {
          return !col.fixed;
        }); //只获取非固定的列
      } // const trStyle = headerHeight&&!fixed ? { height: headerHeight } : (fixed ? this.getHeaderRowStyle(columns, rows) : null);


      var trStyle = this.getHeaderRowStyle(columns, rows); //确保固定列和非固定列表头行高一致

      var drop = draggable ? {
        onDragStart: onDragStart,
        onDragOver: onDragOver,
        onDrop: onDrop,
        onDragEnd: onDragEnd,
        onDragEnter: onDragEnter,
        draggable: draggable
      } : {};
      var dragBorder = dragborder ? {
        onMouseDown: this.onDragBorderMouseDown,
        onMouseMove: onMouseMove,
        onMouseUp: onMouseUp,
        dragborder: dragborder,
        dragborderKey: dragborderKey,
        onDropBorder: onDropBorder,
        onDraggingBorder: onDraggingBorder
      } : {};
      return showHeader ? /*#__PURE__*/React.createElement(TableHeader, _extends({}, drop, dragBorder, {
        columnManager: this.columnManager,
        columnsChildrenList: columnsChildrenList,
        locale: this.props.locale,
        minColumnWidth: minColumnWidth,
        contentWidthDiff: !fixed ? this.state.contentWidthDiff : 0 // contentWidth={this.contentWidth}
        ,
        clsPrefix: clsPrefix,
        rows: rows,
        contentTable: this.contentTable,
        rowStyle: trStyle,
        fixed: fixed,
        filterable: filterable,
        onFilterChange: onFilterChange,
        onFilterClear: onFilterClear,
        filterDelay: filterDelay,
        afterDragColWidth: afterDragColWidth,
        contentDomWidth: this.contentDomWidth,
        scrollbarWidth: this.scrollbarWidth,
        headerScroll: headerScroll,
        bordered: bordered,
        tableUid: this.tableUid,
        leftFixedWidth: leftFixedWidth,
        rightFixedWidth: rightFixedWidth,
        bodyDisplayInRow: bodyDisplayInRow,
        eventNoStop: headerEventNoStop,
        onCopy: onCopy
      })) : null;
    }
  }, {
    key: "getHeaderRows",
    value: function getHeaderRows(options) {
      var _this3 = this;

      var columns = options.columns,
          _options$currentRow = options.currentRow,
          currentRow = _options$currentRow === void 0 ? 0 : _options$currentRow,
          rows = options.rows,
          columnsChildrenList = options.columnsChildrenList;
      var columnKey = this.props.columnKey; // let { contentWidthDiff = 0, lastShowIndex = -1 } = this.state;

      var filterCol = [];
      rows = rows || [];
      rows[currentRow] = rows[currentRow] || []; // let centerShowColCount = 0;

      columns.forEach(function (column, i) {
        if (!column.key) {
          column.key = column[columnKey];
        }

        if (column.rowSpan && rows.length < column.rowSpan) {
          while (rows.length < column.rowSpan) {
            rows.push([]);
          }
        }

        var width = column.width;

        if (typeof width == 'string' && width.indexOf('%') > -1 && _this3.contentWidth) {
          width = Math.ceil(_this3.contentWidth * parseInt(width) / 100);
        } else if (width) {
          width = parseInt(width);
        } // if (!column.fixed && column.ifshow) {
        //   centerShowColCount++;//非固定列显示的个数
        //   if(lastShowIndex+1 == centerShowColCount && width){//对最后一列进行补全宽度
        //     width = width + contentWidthDiff;
        //   }
        // }


        var cell = {
          key: column.key,
          className: column.className || '',
          children: column.title,
          drgHover: column.drgHover,
          fixed: column.fixed,
          width: width,
          dataIndex: column.dataIndex,
          textAlign: column.textAlign,
          titleAlign: column.titleAlign,
          // 标题水平对齐方式
          required: column.required // 标题是否展示必填标志

        };

        if (column.onHeadCellClick) {
          cell.onClick = column.onHeadCellClick;
        }

        if (column.children) {
          _this3.getHeaderRows({
            columns: column.children,
            currentRow: currentRow + 1,
            rows: rows,
            columnsChildrenList: columnsChildrenList
          });
        } else {
          columnsChildrenList && columnsChildrenList.push(column); //复杂表头拖拽，所有叶子节点
        }

        if ('colSpan' in column) {
          cell.colSpan = column.colSpan;
        }

        if ('rowSpan' in column) {
          cell.rowSpan = column.rowSpan;
        }

        if (cell.colSpan !== 0) {
          rows[currentRow].push(cell);
        } //判断是否启用过滤


        if (_this3.props.filterable) {
          //组装Filter需要的Col
          filterCol.push({
            key: column.key,
            children: "过滤渲染",
            width: column.width,
            filtertype: column.filterType,
            //下拉的类型 包括['text','dropdown','date','daterange','number']
            dataIndex: column.dataIndex,
            //field
            datasource: _this3.props.data,
            //需要单独拿到数据处理
            format: column.format,
            //设置日期的格式
            filterdropdown: column.filterDropdown,
            //是否显示 show hide
            filterdropdownauto: column.filterDropdownAuto,
            //是否自定义数据
            filterdropdowndata: column.filterDropdownData,
            //自定义数据格式
            filterdropdownfocus: column.filterDropdownFocus,
            //焦点触发函数回调
            filterdropdowntype: column.filterDropdownType,
            //下拉的类型分为 String,Number 默认是String
            filterdropdownincludekeys: column.filterDropdownIncludeKeys,
            //下拉条件按照指定的keys去显示
            filterinputnumberoptions: column.filterInputNumberOptions //设置数值框内的详细属性

          });
        }
      });

      if (this.props.filterable) {
        rows.push(filterCol);
      }

      return rows.filter(function (row) {
        return row.length > 0;
      });
    }
  }, {
    key: "getExpandedRow",
    value: function getExpandedRow(key, content, visible, className, fixed) {
      var _this$props7 = this.props,
          clsPrefix = _this$props7.clsPrefix,
          expandIconAsCell = _this$props7.expandIconAsCell,
          onPaste = _this$props7.onPaste,
          getCellClassName = _this$props7.getCellClassName;
      var colCount;

      if (fixed === 'left') {
        colCount = this.columnManager.leftLeafColumns().length;
      } else if (fixed === 'right') {
        colCount = this.columnManager.rightLeafColumns().length;
      } else {
        colCount = this.columnManager.centerColumns().length; //计算非固定列的个数，fix: 嵌套表格场景，右侧列断开的问题
      }

      var expandedRowHeight = this.state.fixedColumnsExpandedRowsHeight[key] || 'auto';

      function contentContainer() {
        if (content && content.props && content.props.style) {
          return /*#__PURE__*/React.createElement("div", {
            style: {
              height: content.props.style.height
            }
          });
        } else {
          return ' ';
        }
      }

      var columns = [{
        key: 'extra-row',
        render: function render() {
          return {
            props: {
              colSpan: colCount
            },
            children: !fixed ? content : contentContainer()
          };
        }
      }];

      if (expandIconAsCell && fixed !== 'right') {
        columns.unshift({
          key: 'expand-icon-placeholder',
          render: function render() {
            return null;
          }
        });
      }

      return /*#__PURE__*/React.createElement(TableRow, {
        tableUid: this.tableUid,
        onPaste: onPaste,
        columns: columns,
        visible: visible,
        className: className,
        key: "".concat(key, "-extra-row"),
        clsPrefix: "".concat(clsPrefix, "-expanded-row"),
        indent: 1,
        expandable: false,
        store: this.store,
        dragborderKey: this.props.dragborderKey,
        rowDraggAble: this.props.rowDraggAble,
        useDragHandle: this.props.useDragHandle,
        onDragRow: this.onDragRow,
        onDragRowStart: this.onDragRowStart,
        height: expandedRowHeight,
        getCellClassName: getCellClassName
      });
    } //列宽度拖拽-鼠标按下的事件

  }, {
    key: "getRowsByData",
    value:
    /**
     *
     *
     * @param {*} data
     * @param {*} visible
     * @param {*} indent 层级
     * @param {*} columns
     * @param {*} fixed
     * @param {number} [rootIndex=-1] 祖级节点
     * @returns
     * @memberof Table
     */
    function getRowsByData(data, visible, indent, columns, fixed) {
      var rootIndex = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : -1;
      var props = this.props;
      var childrenColumnName = props.childrenColumnName;
      var expandedRowRender = props.expandedRowRender;
      var expandRowByClick = props.expandRowByClick;
      var onPaste = props.onPaste;
      var anyColumnsFixed = this.columnManager.isAnyColumnsFixed();
      var fixedColumnsBodyRowsHeight = this.state.fixedColumnsBodyRowsHeight;
      var rst = [];
      var height;
      var rowClassName = props.rowClassName;
      var rowRef = props.rowRef;
      var expandedRowClassName = props.expandedRowClassName;
      var needIndentSpaced = props.data.some(function (record) {
        return record[childrenColumnName];
      });
      var onRowClick = props.onRowClick;
      var onRowDoubleClick = props.onRowDoubleClick;
      var expandIconAsCell = fixed !== 'right' ? props.expandIconAsCell : false;
      var expandIconColumnIndex = props.expandIconColumnIndex;

      if (props.lazyLoad && props.lazyLoad.preHeight && indent == 0) {
        // console.log("AAA--->lazyLoad--first->"+props.lazyLoad.preHeight);
        rst.push( /*#__PURE__*/React.createElement(TableRow, {
          onPaste: onPaste,
          height: props.lazyLoad.preHeight,
          columns: [],
          className: "table_lazyload_row_first",
          key: 'table_lazyload_row_first',
          store: this.store,
          visible: true
        }));
      }

      var leafColumns;

      if (fixed === 'left') {
        leafColumns = this.columnManager.leftLeafColumns();
      } else if (fixed === 'right') {
        leafColumns = this.columnManager.rightLeafColumns();
      } else {
        leafColumns = this.columnManager.leafColumns();
      }

      var lazyCurrentIndex = props.lazyLoad && props.lazyLoad.startIndex ? props.lazyLoad.startIndex : 0;
      var lazyParentIndex = props.lazyLoad && props.lazyLoad.startParentIndex ? props.lazyLoad.startParentIndex : 0;
      var lazyEndIndex = props.lazyLoad && props.lazyLoad.endIndex ? props.lazyLoad.endIndex : -1;

      for (var i = 0; i < data.length; i++) {
        var isHiddenExpandIcon = void 0;
        var record = data[i];
        var key = this.getRowKey(record, i); // 兼容 NCC 以前的业务逻辑，支持外部通过 record 中的 isleaf 字段，判断是否为叶子节点
        // record['_isLeaf'] = typeof record['isleaf'] === 'boolean' ? record['isleaf'] : record['_isLeaf'];

        if (typeof record['isleaf'] === 'boolean') {
          record['_isLeaf'] = record['isleaf']; //如果isleaf存在并且为boolean的情况下才生成_isLeaf，否则无需生成
        } // _isLeaf 字段是在 bigData 里添加的，只有层级树大数据场景需要该字段
        // _isLeaf 有三种取值情况：true / false / null。（Table内部字段）


        var _isLeaf = typeof record['_isLeaf'] === 'boolean' ? record['_isLeaf'] : null;

        var childrenColumn = _isLeaf ? false : record[childrenColumnName];
        var isRowExpanded = this.isRowExpanded(record, i);
        var expandedRowContent = void 0;
        var expandedContentHeight = 0; //fixedIndex一般是跟index是一个值的，只有是树结构时，会讲子节点的值也累计上

        var fixedIndex = i; //判断是否是tree结构

        if (this.treeType) {
          fixedIndex = this.treeRowIndex;
        }

        if (expandedRowRender && isRowExpanded) {
          expandedRowContent = expandedRowRender(record, fixedIndex + lazyCurrentIndex, indent);
          expandedContentHeight = parseInt(expandedRowContent.props && expandedRowContent.props.style && expandedRowContent.props.style.height ? expandedRowContent.props.style.height : 0);
        } //只有当使用expandedRowRender参数的时候才去识别isHiddenExpandIcon（隐藏行展开的icon）


        if (expandedRowRender && typeof props.haveExpandIcon == 'function') {
          isHiddenExpandIcon = props.haveExpandIcon(record, i);
        }

        if (props.bodyDisplayInRow) {
          //内容显示不换行，即显示为"..."
          if (anyColumnsFixed) {
            //存在固定列则强制同步行高度，以确保行不会错位
            height = props.height ? props.height : fixedColumnsBodyRowsHeight[fixedIndex];
          } else {
            //不存在固定列，则按指定高度呈现行
            height = props.height || 40;
          }
        } else {
          //内容自适应行高
          if (anyColumnsFixed) {
            //存在固定列则强制同步行高度，以确保行不会错位
            height = fixedColumnsBodyRowsHeight[fixedIndex];
          } else {//不存在固定列，则按内容高度自行呈现
          }
        } // if (props.bodyDisplayInRow && props.height) {
        //   height = props.height
        // } else if(fixed || props.heightConsistent) {
        //   height = fixedColumnsBodyRowsHeight[fixedIndex];
        // }


        var className = rowClassName(record, fixedIndex + lazyCurrentIndex, indent); //合计代码如果是最后一行并且有合计功能时，最后一行为合计列

        if (i == data.length - 1 && props.showSum) {
          className = className + ' sumrow';
        }

        var paramRootIndex = rootIndex; //小于0说明为第一层节点，她的子孙节点要保存自己的根节点

        if (paramRootIndex < 0) {
          paramRootIndex = i + lazyParentIndex;
        }

        var index = i;

        if (rootIndex == -1) {
          index = i + lazyParentIndex;
        }

        rst.push( /*#__PURE__*/React.createElement(TableRow, {
          onPaste: onPaste,
          indent: indent,
          indentSize: props.indentSize,
          needIndentSpaced: needIndentSpaced,
          className: "".concat(className),
          record: record,
          expandIconAsCell: expandIconAsCell,
          onDestroy: this.onRowDestroy,
          index: index,
          visible: visible,
          expandRowByClick: expandRowByClick,
          onExpand: this.onExpanded,
          expandable: expandedRowRender || (childrenColumn && childrenColumn.length > 0 ? true : _isLeaf === false),
          expanded: isRowExpanded,
          clsPrefix: "".concat(props.clsPrefix, "-row"),
          childrenColumnName: childrenColumnName,
          columns: leafColumns,
          expandIconColumnIndex: expandIconColumnIndex,
          onRowClick: onRowClick,
          onRowDoubleClick: onRowDoubleClick,
          height: height,
          isHiddenExpandIcon: isHiddenExpandIcon,
          onHover: this.handleRowHover,
          key: "table_row_" + key + "_" + index,
          hoverKey: key,
          ref: rowRef,
          store: this.store,
          fixed: fixed,
          expandedContentHeight: expandedContentHeight,
          setRowHeight: props.setRowHeight,
          setRowParentIndex: props.setRowParentIndex,
          treeType: childrenColumn || this.treeType ? true : false,
          fixedIndex: fixedIndex + lazyCurrentIndex,
          rootIndex: rootIndex,
          syncHover: props.syncHover,
          bodyDisplayInRow: props.bodyDisplayInRow,
          rowDraggAble: props.rowDraggAble,
          useDragHandle: props.useDragHandle,
          onDragRow: this.onDragRow,
          onDragRowStart: this.onDragRowStart,
          contentTable: this.contentTable,
          tableUid: this.tableUid,
          expandedIcon: props.expandedIcon,
          collapsedIcon: props.collapsedIcon,
          lazyStartIndex: lazyCurrentIndex,
          lazyEndIndex: lazyEndIndex,
          centerColumnsLength: this.centerColumnsLength,
          leftColumnsLength: this.leftColumnsLength,
          expandIconCellWidth: expandIconCellWidth,
          getCellClassName: props.getCellClassName
        }));
        this.treeRowIndex++;
        var subVisible = visible && isRowExpanded;

        if (expandedRowContent && isRowExpanded) {
          rst.push(this.getExpandedRow(key, expandedRowContent, subVisible, expandedRowClassName(record, i, indent), fixed));
        }

        if (childrenColumn) {
          this.isTreeType = true; //增加该标志位，为了兼容老版本，不修改以前的 `this.treeType` 的相关逻辑

          this.treeType = true; //证明是tree表形式visible = {true}

          rst = rst.concat(this.getRowsByData(childrenColumn, subVisible, indent + 1, columns, fixed, paramRootIndex));
        }
      }

      if (props.lazyLoad && props.lazyLoad.sufHeight && indent == 0) {
        //console.log("AAA--->lazyLoad---last-->"+props.lazyLoad.sufHeight);
        rst.push( /*#__PURE__*/React.createElement(TableRow, {
          onPaste: onPaste //containerWidth={this.contentDomWidth} isSuf //滚动loading相关的暂时不用
          ,
          height: props.lazyLoad.sufHeight,
          key: 'table_lazyload_row_end',
          columns: [],
          className: "table_lazyload_row_end",
          store: this.store,
          visible: true
        }));
      }

      if (!this.isTreeType) {
        this.treeType = false;
      }

      return rst;
    }
  }, {
    key: "getRows",
    value: function getRows(columns, fixed) {
      //统计index，只有含有树表结构才有用，因为树表结构时，固定列的索引取值有问题
      this.treeRowIndex = 0; //每次遍历 data 前，将this.isTreeType置为 false，若遍历完 data，此变量仍为 false，说明是普通表格

      this.isTreeType = false;
      var rs = this.getRowsByData(this.state.data, true, 0, columns, fixed);
      return rs;
    }
  }, {
    key: "getColGroup",
    value: function getColGroup(columns, fixed) {
      var cols = [];
      var self = this;
      var _this$state = this.state,
          _this$state$contentWi = _this$state.contentWidthDiff,
          contentWidthDiff = _this$state$contentWi === void 0 ? 0 : _this$state$contentWi,
          _this$state$lastShowI = _this$state.lastShowIndex,
          lastShowIndex = _this$state$lastShowI === void 0 ? -1 : _this$state$lastShowI;

      if (this.props.expandIconAsCell && fixed !== 'right') {
        cols.push( /*#__PURE__*/React.createElement("col", {
          className: "".concat(this.props.clsPrefix, "-expand-icon-col"),
          key: "".concat(prefix, "-table-expand-icon-col")
        }));
      }

      var leafColumns;

      if (fixed === 'left') {
        contentWidthDiff = 0;
        leafColumns = this.columnManager.leftLeafColumns();
      } else if (fixed === 'right') {
        contentWidthDiff = 0;
        leafColumns = this.columnManager.rightLeafColumns();
      } else {
        leafColumns = this.columnManager.centerLeafColumns();
      }

      cols = cols.concat(leafColumns.map(function (c, i, arr) {
        var fixedClass = '';
        var width = c.width;

        if (typeof width == 'string' && width.indexOf('%') > -1 && self.contentWidth) {
          width = Math.ceil(self.contentWidth * parseInt(width) / 100);
        } else if (width) {
          width = parseInt(width);
        } //中间区域非固定的最后一列自动补充宽度


        if (!fixed && lastShowIndex == i && width) {
          width = width + (contentWidthDiff < 0 ? 0 : contentWidthDiff);
        } // if (!fixed && c.fixed) {//之前中间区域会渲染固定列dom单不让显示，现在直接不渲染dom了，所以需要了
        //   fixedClass = ` ${this.props.clsPrefix}-row-fixed-columns-in-body`;
        // }


        return /*#__PURE__*/React.createElement("col", {
          key: c.key || c.dataIndex,
          style: {
            width: width,
            minWidth: c.width
          },
          className: fixedClass || null
        });
      }));
      return /*#__PURE__*/React.createElement("colgroup", {
        className: "".concat(prefix, "-table-colgroup")
      }, cols);
    } // renderDragHideTable = () => {
    //   const { columns,clsPrefix, dragborder, dragborderKey } = this.props;
    //   if (!dragborder) return null;
    //   let sum = 0;
    //   return (<div id={`u-table-drag-hide-table-${dragborderKey}`} className={`${clsPrefix}-hiden-drag`} >
    //     {
    //       columns.map((da, i) => {
    //         sum += da.width ? parseInt(da.width) : 0;
    //         return (<div className={`${clsPrefix}-hiden-drag-li`} key={da + "_hiden_" + i} style={{ left: sum + "px" }}></div>);
    //       })
    //     }
    //   </div>);
    // }

  }, {
    key: "getLeftFixedTable",
    value: function getLeftFixedTable() {
      return this.getTable({
        columns: this.columnManager.leftColumns(),
        fixed: 'left'
      });
    }
  }, {
    key: "getRightFixedTable",
    value: function getRightFixedTable() {
      return this.getTable({
        columns: this.columnManager.rightColumns(),
        fixed: 'right'
      });
    }
  }, {
    key: "getTable",
    value: function getTable() {
      var _this4 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var columns = options.columns,
          fixed = options.fixed;
      var _this$props8 = this.props,
          clsPrefix = _this$props8.clsPrefix,
          data = _this$props8.data,
          bordered = _this$props8.bordered,
          _this$props8$scroll = _this$props8.scroll,
          scroll = _this$props8$scroll === void 0 ? {} : _this$props8$scroll,
          getBodyWrapper = _this$props8.getBodyWrapper,
          footerScroll = _this$props8.footerScroll,
          headerScroll = _this$props8.headerScroll,
          _this$props8$hideHead = _this$props8.hideHeaderScroll,
          hideHeaderScroll = _this$props8$hideHead === void 0 ? false : _this$props8$hideHead,
          expandIconAsCell = _this$props8.expandIconAsCell;
      var useFixedHeader = this.props.useFixedHeader; // let变量声明

      var bodyStyle = _objectSpread({}, this.props.bodyStyle); // 克隆一份


      var headStyle = {};
      var innerBodyStyle = {};
      var leftFixedWidth = this.columnManager.getLeftColumnsWidth(this.contentWidth); // gx + (bordered ? 1 : 0); // 边框table需要把左边的1像素边框加上

      var rightFixedWidth = this.columnManager.getRightColumnsWidth(this.contentWidth); // gx + (browserInfo.browserType=='IE' ? 16 : 0); // IE右侧固定列会被横竖滚动条影响一些宽度

      var tableClassName = fixed ? "".concat(clsPrefix, "-fixed") : '';

      if (scroll.x || fixed //|| this.contentDomWidth < this.contentWidth  //表格元素的宽度大于容器的宽度也显示滚动条
      ) {
        //没有数据并且含有顶部菜单时
        if (data.length == 0 && this.props.headerScroll) {
          bodyStyle.overflowX = 'hidden';
        }

        if (!footerScroll) {
          bodyStyle.overflowX = bodyStyle.overflowX || 'auto';
        }
      }

      if (scroll.y) {
        // maxHeight will make fixed-Table scrolling not working
        // so we only set maxHeight to body-Table here
        if (fixed) {
          //固定表格
          // bodyStyle.height = bodyStyle.height || scroll.y;
          innerBodyStyle.minHeight = bodyStyle.minHeight || scroll.y;
          innerBodyStyle.maxHeight = bodyStyle.maxHeight || scroll.y;
          innerBodyStyle.overflowY = bodyStyle.overflowY || 'auto'; // gx解决底部滚动条的显示问题
          // if (this.computeWidth > this.contentDomWidth) {
          //   innerBodyStyle.overflowX = 'scroll';
          // } else if (this.contentWidth === this.contentDomWidth) {
          //   innerBodyStyle.overflowX = 'hidden';
          // }
        } else {
          bodyStyle.maxHeight = bodyStyle.maxHeight || scroll.y;
        }

        bodyStyle.overflowY = bodyStyle.overflowY || 'auto';
        useFixedHeader = true; // Add negative margin bottom for scroll bar overflow bug
        // const scrollbarWidth = this.scrollbarWidth;
        // if (scrollbarWidth >= 0) {
        //   (fixed ? bodyStyle : headStyle).paddingBottom = '0px';
        //   //显示表头滚动条
        //   if(headerScroll){
        //     if(fixed){
        //
        //      if(this.domWidthDiff <= 0){
        //         headStyle.marginBottom = `${scrollbarWidth}px`;
        //         bodyStyle.marginBottom = `-${scrollbarWidth}px`;
        //       }else{
        //         innerBodyStyle.overflowX = 'auto';
        //       }
        //     }else{
        //          //内容少，不用显示滚动条
        //          if(this.domWidthDiff > 0){
        //           headStyle.overflowX = 'hidden';
        //         }
        //       headStyle.marginBottom = `0px`;
        //     }
        //   }else{
        //     if(fixed){
        //       if(this.domWidthDiff > 0){
        //         headStyle.overflow = 'hidden';
        //         innerBodyStyle.overflowX = 'auto'; //兼容expand场景、子表格含有固定列的场景
        //       }else{
        //         // 海龙为了解决固定右侧滚动条Firefox下的现象问题，解决方案不合适，暂时不用，还原
        //         // if (this.computeWidth > this.contentDomWidth) {
        //         //   bodyStyle.marginBottom = '-' + scrollbarWidth + 'px';
        //         //   const userAgent = navigator.userAgent; // 火狐，IE浏览器，固定表格跟随resize事件产生的滚动条隐藏
        //         //   const isFF = userAgent.indexOf("Firefox") > -1;
        //         //   const isIE = !!window.ActiveXObject || "ActiveXObject" in window
        //         //   if (isFF || isIE) {
        //         //     // innerBodyStyle.overflowX = 'hidden';
        //         //     delete innerBodyStyle.overflowX
        //         //   }
        //         // }
        //         bodyStyle.marginBottom = `-${scrollbarWidth}px`;
        //       }
        //
        //     }else{
        //         // // 没有数据时，表头滚动条隐藏问题
        //         // if(data.length == 0 && this.domWidthDiff < 0){
        //         //   headStyle.marginBottom = '0px';
        //         // }else{
        //         //   headStyle.marginBottom = `-${scrollbarWidth}px`;
        //         // }
        //
        //     }
        //
        //   }
        // }
      } // if(data.length == 0 && hideHeaderScroll){
      //   //支持 NCC 需求:表格无数据时，去掉表头滚动条 (https://github.com/iuap-design/tinper-bee/issues/207)
      //   headStyle.marginBottom = `-${this.scrollbarWidth}px`;
      // }
      //----------------水平滚动条的显示处理-------------
      //没有数据时


      if (data.length == 0) {
        if (fixed) {
          //固定列头部滚水平动条隐藏
          headStyle.overflowX = 'hidden';
        } else {
          //中间列头部水平滚动条自动显示
          headStyle.overflowX = 'auto';
        }
      } else {
        //有数据时，头部水平滚动条隐藏
        headStyle.overflowX = 'hidden';
      } //强制固定列和中间列隐藏头部水平滚动条，


      if (hideHeaderScroll) {
        headStyle.overflowX = 'hidden';
      } //---------------垂直滚动条的显示处理---------------


      if (data.length == 0) {
        bodyStyle.overflowY = 'hidden';
        innerBodyStyle.overflowY = 'hidden';
        headStyle.overflowY = 'hidden';
      } else {
        bodyStyle.overflowY = bodyStyle.overflowY || 'auto';
        innerBodyStyle.overflowY = bodyStyle.overflowY;
        headStyle.overflowY = innerBodyStyle.overflowY;
      }

      var renderTable = function renderTable() {
        var hasHead = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var hasBody = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        var options = arguments.length > 2 ? arguments[2] : undefined;
        var columns = options.columns,
            fixed = options.fixed;
        var tableStyle = {};

        if (!fixed && scroll.x) {
          //非固定列的中间表格
          // not set width, then use content fixed width
          if (scroll.x === true) {
            tableStyle.tableLayout = 'fixed';
          } else {
            // tableStyle.width = this.contentWidth - this.columnManager.getLeftColumnsWidth(this.contentWidth) - this.columnManager.getRightColumnsWidth(this.contentWidth);
            tableStyle.width = scroll.x;
          }
        } // // 自动出现滚动条
        // if ( !fixed && this.contentDomWidth < this.contentWidth) {
        //   tableStyle.width = this.contentWidth - this.columnManager.getLeftColumnsWidth(this.contentWidth) - this.columnManager.getRightColumnsWidth(this.contentWidth);
        // }
        // by gx
        // if (this.bodyTable && !fixed && this.contentDomWidth === this.contentWidth) {
        //   tableStyle.width = this.bodyTable.clientWidth
        // }


        var tableBody = hasBody ? getBodyWrapper( /*#__PURE__*/React.createElement("tbody", {
          className: "".concat(clsPrefix, "-tbody"),
          onMouseLeave: _this4.onBodyMouseLeave
        }, _this4.getRows(columns, fixed))) : null;

        var _drag_class = _this4.props.dragborder ? "table-drag-bordered" : "";

        return /*#__PURE__*/React.createElement("table", {
          className: " ".concat(tableClassName, "  table-bordered ").concat(_drag_class, " "),
          style: tableStyle,
          "data-for-table": _this4.tableUid
        }, _this4.getColGroup(columns, fixed), hasHead ? _this4.getHeader(columns, fixed, leftFixedWidth, rightFixedWidth) : null, tableBody);
      };

      var headTable;

      if (useFixedHeader) {
        headTable = /*#__PURE__*/React.createElement("div", {
          className: "".concat(clsPrefix, "-header"),
          ref: function ref(el) {
            fixed ? _this4.fixedHeadTable = el : _this4.headTable = el;
          },
          style: headStyle // onMouseOver={this.detectScrollTarget}
          // onTouchStart={this.detectScrollTarget}
          ,
          onScroll: this.handleBodyScroll
        }, renderTable(true, false, options));
      }

      var BodyTable =
      /*#__PURE__*/
      //中间表格的body
      React.createElement("div", {
        className: "".concat(clsPrefix, "-body"),
        style: bodyStyle,
        ref: function ref(el) {
          _this4.bodyTable = el;
        } // onMouseOver={this.detectScrollTarget}
        // onTouchStart={this.detectScrollTarget}
        ,
        onScroll: this.handleBodyScroll,
        onMouseLeave: this.onBodyMouseLeave
      }, renderTable(!useFixedHeader, true, options));

      if (fixed && columns.length) {
        //固定表格的body
        delete bodyStyle.overflowX;
        delete bodyStyle.overflowY;
        BodyTable = /*#__PURE__*/React.createElement("div", {
          className: "".concat(clsPrefix, "-body-outer"),
          style: _objectSpread({}, bodyStyle)
        }, /*#__PURE__*/React.createElement("div", {
          style: _objectSpread({}, innerBodyStyle),
          className: "".concat(clsPrefix, "-body-inner"),
          ref: function ref(_ref) {
            switch (fixed) {
              case "left":
                _this4.fixedLeftBodyInner = _ref;
                break;

              case "right":
                _this4.fixedRightBodyInner = _ref;
                break;
            }
          } // onMouseOver={this.detectScrollTarget}
          // onTouchStart={this.detectScrollTarget}
          ,
          onScroll: this.handleBodyScroll
        }, renderTable(!useFixedHeader, true, options)));
      } // const leftFixedWidth = this.columnManager.getLeftColumnsWidth(this.contentWidth);
      // const rightFixedWidth = this.columnManager.getRightColumnsWidth(this.contentWidth);


      var expandIconWidth = expandIconAsCell ? 32 : 0;
      var parStyle = {};

      if (!fixed) {
        var hasFixedLeft = this.columnManager.isAnyColumnsLeftFixed();
        parStyle = {
          'marginLeft': leftFixedWidth + expandIconWidth + (bordered && hasFixedLeft ? -1 : 0),
          'marginRight': rightFixedWidth
        };
      }

      return /*#__PURE__*/React.createElement("div", {
        style: parStyle
      }, headTable, BodyTable);
    }
  }, {
    key: "getTitle",
    value: function getTitle() {
      var _this$props9 = this.props,
          title = _this$props9.title,
          clsPrefix = _this$props9.clsPrefix;
      return title ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-title")
      }, title(this.state.data)) : null;
    }
  }, {
    key: "getFooter",
    value: function getFooter() {
      var _this$props10 = this.props,
          footer = _this$props10.footer,
          clsPrefix = _this$props10.clsPrefix;
      return footer ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-footer")
      }, footer(this.state.data)) : null;
    }
  }, {
    key: "getEmptyText",
    value: function getEmptyText() {
      var _this$props11 = this.props,
          defaultEmptyText = _this$props11.emptyText,
          clsPrefix = _this$props11.clsPrefix,
          data = _this$props11.data;
      var locale = getComponentLocale(this.props, this.context, 'Table', function () {
        return i18n;
      });
      var emptyText = defaultEmptyText !== undefined ? defaultEmptyText : function () {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
          src: noDataImg,
          className: "table-nodata",
          alt: ""
        }), /*#__PURE__*/React.createElement("span", null, locale["no_data"]));
      };
      return !data.length ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-placeholder")
      }, emptyText()) : null;
    }
  }, {
    key: "getHeaderRowStyle",
    value: function getHeaderRowStyle(columns, rows) {
      var fixedColumnsHeadRowsHeight = this.state.fixedColumnsHeadRowsHeight;
      var headerHeight = fixedColumnsHeadRowsHeight[0];

      if (headerHeight && columns) {
        if (headerHeight === 'auto') {
          return {
            height: 'auto'
          };
        }

        return {
          height: headerHeight / rows.length
        };
      }

      return null;
    } // getStyle(obj,attr){
    //   if(obj.currentStyle){
    //       return obj.currentStyle[attr];
    //   }
    //   else{
    //       return document.defaultView.getComputedStyle(obj,null)[attr];
    //   }
    // }
    // getTdPadding=(td)=>{
    //   let tdPaddingTop = this.getStyle(td,'paddingTop'),tdPaddingBottom = this.getStyle(td,'paddingBottom'),
    //   tdBorderTop = this.getStyle(td,'borderTopWidth'),tdBorderBottom = this.getStyle(td,'borderBottomWidth');
    //   return Number(tdPaddingTop.replace('px',''))+Number(tdPaddingBottom.replace('px',''))+Number(tdBorderTop.replace('px',''))+Number(tdBorderBottom.replace('px',''))
    //
    // }
    // getFlatRecords = data => {
    //   var result = []
    //   for (var i = 0; i < data.length; i++) {
    //     result.push(data[i])
    //     if ((data[i].children || []).length) {
    //       result = result.concat(this.getFlatRecords(data[i].children))
    //     }
    //   }
    //   return result
    // };
    //add by gx 供外部数据变更时调用此方法同步内容行高度

  }, {
    key: "manualSyncFixedTableRowHeight",
    value: function manualSyncFixedTableRowHeight() {
      this.dataChanged = true;
      this.syncFixedTableRowHeight();
    }
  }, {
    key: "syncFixedTableRowHeight",
    value: function syncFixedTableRowHeight() {
      var _this5 = this;

      //this.props.height、headerHeight分别为用户传入的行高和表头高度，如果有值，所有行的高度都是固定的，主要为了避免在千行数据中有固定列时获取行高度有问题
      var _this$props12 = this.props,
          clsPrefix = _this$props12.clsPrefix,
          height = _this$props12.height,
          headerHeight = _this$props12.headerHeight,
          columns = _this$props12.columns,
          heightConsistent = _this$props12.heightConsistent,
          bodyDisplayInRow = _this$props12.bodyDisplayInRow,
          lazyLoad = _this$props12.lazyLoad,
          syncFixedRowHeight = _this$props12.syncFixedRowHeight;
      var headRows = this.headTable ? this.headTable.querySelectorAll('thead') : this.bodyTable ? this.bodyTable.querySelectorAll('thead') : [];
      var expandedRows = this.bodyTable && this.bodyTable.querySelectorAll(".".concat(clsPrefix, "-expanded-row[data-for-table='").concat(this.tableUid, "']")) || [];
      var bodyRows = this.bodyTable && this.bodyTable.querySelectorAll(".".concat(clsPrefix, "-row[data-for-table='").concat(this.tableUid, "']")) || [];
      var leftBodyRows = !this.dataChanged && this.fixedLeftBodyInner && this.fixedLeftBodyInner.querySelectorAll(".".concat(clsPrefix, "-row[data-for-table='").concat(this.tableUid, "']")) || [];
      var rightBodyRows = !this.dataChanged && this.fixedRightBodyInner && this.fixedRightBodyInner.querySelectorAll(".".concat(clsPrefix, "-row[data-for-table='").concat(this.tableUid, "']")) || [];
      this.dataChanged = false;
      var fixedColumnsHeadRowsHeight = [].map.call(headRows, function (row) {
        var height = headerHeight;

        if (headerHeight) {
          height = (getMaxColChildrenLength(columns) + 1) * headerHeight;
        }

        return headerHeight ? height : Math.ceil(row.getBoundingClientRect().height) || 'auto';
      } //向上取整
      ); // const flatRecords = this.getFlatRecords(this.props.data || [])
      // const fixedColumnsBodyRowsHeight = [].map.call(
      //   bodyRows, (row,index) =>{
      //     let rsHeight = height;
      //     if(bodyDisplayInRow && rsHeight){
      //       return rsHeight;
      //     }else{
      //       const rowKey = row.getAttribute('data-row-key')
      //       const record = flatRecords.find(record => record.key === rowKey) || {}
      //       const leafKey = 'isleaf' in record ? 'isleaf' : '_isLeaf' in record ? '_isLeaf' : null // ncc传递这俩属性区分是否是子节点
      //       const isLeaf = leafKey && record[leafKey] === true
      //       if (isLeaf) {
      //         return Number((Number(row.getBoundingClientRect().height)).toFixed(2)) || 'auto';
      //       }
      //       // 为了提高性能，默认获取主表的高度，但是有的场景中固定列的高度比主表的高度高，所以提供此属性，会统计所有列的高度取最大的，设置
      //       // 内容折行显示，并又设置了 height 的情况下，也要获取主表高度
      //       if(heightConsistent || (!bodyDisplayInRow && rsHeight && syncFixedRowHeight)){
      //         let leftHeight,rightHeight,currentHeight,maxHeight;
      //         leftHeight = leftBodyRows[index]?Number(leftBodyRows[index].getBoundingClientRect().height).toFixed(2):0; // 有些浏览器中，取到的高度是小数，直接parseInt有问题，保留两位小数处理
      //         rightHeight = rightBodyRows[index]?Number(rightBodyRows[index].getBoundingClientRect().height).toFixed(2):0;
      //         currentHeight = Number(row.getBoundingClientRect().height).toFixed(2)
      //         maxHeight = Math.max(leftHeight,rightHeight,currentHeight);
      //         return maxHeight || 'auto'
      //       }else{
      //         return Number((Number(row.getBoundingClientRect().height)).toFixed(2)) || 'auto';
      //       }
      //     }
      //   }
      // );
      //add by zzj

      var getMax = function getMax(a, b, c) {
        //求三个数的最大值
        return a > b ? a > c ? a : c : b > c ? b : c;
      }; // 记录表格各行高缓存


      this.fixedColumnsBodyRowsHeightCache = this.fixedColumnsBodyRowsHeightCache || {}; // 计算出表格各行的最大高度（非折叠展开行）

      var fixedColumnsBodyRowsHeight = [];
      bodyRows.length > 0 && [].forEach.call(bodyRows, function (row, i) {
        var rsHeight = height;

        if (bodyDisplayInRow && rsHeight) {
          rsHeight = height; //使用指定的固定行高
        } else {
          //使用自适应行高
          var rsKey = row.getAttribute("data-row-key");

          if (browserInfo.browserType == 'IE' && _this5.fixedColumnsBodyRowsHeightCache[rsKey]) {
            //暂时仅ie下走缓存，解决ie下的自动增长行高的问题
            rsHeight = _this5.fixedColumnsBodyRowsHeightCache[rsKey]; //console.log("AAA--->fixedColumnsBodyRowsHeight->cache")
          } else {
            rsHeight = getMax(leftBodyRows.length ? Math.ceil(leftBodyRows[i].getBoundingClientRect().height) : 0, rightBodyRows.length ? Math.ceil(rightBodyRows[i].getBoundingClientRect().height) : 0, Math.ceil(row.getBoundingClientRect().height));
            _this5.fixedColumnsBodyRowsHeightCache[rsKey] = rsHeight;
          }
        }

        fixedColumnsBodyRowsHeight[i] = rsHeight;
      }); //console.log("AAA--->fixedColumnsBodyRowsHeight->" + fixedColumnsBodyRowsHeight)
      // 记录表格各折叠行高缓存

      this.fixedColumnsExpandedRowsHeightCache = this.fixedColumnsExpandedRowsHeightCache || {}; // 计算出表格各折叠展开行的高度

      var fixedColumnsExpandedRowsHeight = {};
      expandedRows.length > 0 && [].forEach.call(expandedRows, function (row) {
        var parentRowKey = row && row.previousSibling && row.previousSibling.getAttribute("data-row-key"); // fix: ie 展开表格计算渲染bug
        // try {//子表数据减少时，动态计算高度
        //   let td = row.querySelector('td');
        //   let tdPadding = this.getTdPadding(td);
        //   let trueheight = parseInt(row.querySelectorAll('.u-table')[0].getBoundingClientRect().height);
        //   exHeight = trueheight+tdPadding;
        // } catch (error) {
        // }

        if (browserInfo.browserType == 'IE' && _this5.fixedColumnsExpandedRowsHeightCache[parentRowKey]) {
          //暂时仅ie下走缓存，解决ie下的自动增长行高的问题
          fixedColumnsExpandedRowsHeight[parentRowKey] = _this5.fixedColumnsExpandedRowsHeightCache[parentRowKey];
        } else {
          var exHeight = row && Math.ceil(row.getBoundingClientRect().height) || 'auto';
          fixedColumnsExpandedRowsHeight[parentRowKey] = exHeight;
          _this5.fixedColumnsExpandedRowsHeightCache[parentRowKey] = exHeight;
        }
      });

      if (shallowequal(this.state.fixedColumnsHeadRowsHeight, fixedColumnsHeadRowsHeight) && shallowequal(this.state.fixedColumnsBodyRowsHeight, fixedColumnsBodyRowsHeight) && shallowequal(this.state.fixedColumnsExpandedRowsHeight, fixedColumnsExpandedRowsHeight)) {
        return;
      } //add by zzj
      // clearTimeout(this.timer);
      // this.timer = setTimeout(() => {


      var updateRowHeightState = function updateRowHeightState() {
        console.log("AAA----->setTimeout");

        _this5.setState({
          fixedColumnsHeadRowsHeight: fixedColumnsHeadRowsHeight,
          fixedColumnsBodyRowsHeight: fixedColumnsBodyRowsHeight,
          fixedColumnsExpandedRowsHeight: fixedColumnsExpandedRowsHeight
        }, function () {
          var center = _this5.bodyTable;
          var left = _this5.fixedLeftBodyInner;
          var right = _this5.fixedRightBodyInner; //滚动条在最底部并且表格行高变化时，inner部分scrollTop数值不一致造成的表格没对齐。

          if (_this5.columnManager.isAnyColumnsRightFixed()) {
            if (center && right && center.scrollTop !== right.scrollTop) {
              center.scrollTop = right.scrollTop;
            }

            if (center && left && left.scrollTop !== right.scrollTop) {
              left.scrollTop = right.scrollTop;
            }
          } else {
            if (center && left && center.scrollTop !== left.scrollTop) {
              left.scrollTop = center.scrollTop;
            }
          }
        }); // }, 10);

      };

      debounce(updateRowHeightState(), 100);
    }
  }, {
    key: "resetScrollX",
    value: function resetScrollX() {
      if (this.headTable) {
        this.headTable.scrollLeft = 0;
      }

      if (this.bodyTable) {
        this.bodyTable.scrollLeft = 0;
      }
    }
  }, {
    key: "findExpandedRow",
    value: function findExpandedRow(record, index) {
      var _this6 = this;

      var rows = this.getExpandedRows().filter(function (i) {
        return i === _this6.getRowKey(record, index);
      });
      return rows[0];
    }
  }, {
    key: "isRowExpanded",
    value: function isRowExpanded(record, index) {
      return typeof this.findExpandedRow(record, index) !== 'undefined';
    }
  }, {
    key: "onBodyMouseLeave",
    value: function onBodyMouseLeave(e) {
      this.hideHoverDom(e);
      var onBodyMouseLeave = this.props.onBodyMouseLeave;

      if (typeof onBodyMouseLeave === 'function') {
        this.clearBodyMouseLeaveTimer(); //因为鼠标移动到 hoverContent 中也会触发 onBodyMouseLeave，这是错误的
        //所以讲 onBodyMouseLeave 回调的调用放入 setTimeout中，
        // 当触发 hoverContent 的 onRowHoverMouseEnter 回调时，清除此定时器

        this.bodyMouseLeaveTimmer = setTimeout(onBodyMouseLeave, 0);
      }
    }
    /*
    detectScrollTarget(e) {
      if (this.scrollTarget !== e.currentTarget) {
        this.scrollTarget = e.currentTarget;
      }
    }
    */
    //隐藏行上悬浮的自定义dom

  }, {
    key: "hideHoverDom",
    value: function hideHoverDom(e) {
      if (this.hoverDom) {
        this.hoverDom.style.display = 'none';
      }
    } //处理表格体内滚动

  }, {
    key: "handleBodyScroll",
    value: function handleBodyScroll(e) {
      var _this7 = this;

      var _this$props13 = this.props,
          _this$props13$scroll = _this$props13.scroll,
          scroll = _this$props13$scroll === void 0 ? {} : _this$props13$scroll,
          clsPrefix = _this$props13.clsPrefix,
          handleScrollY = _this$props13.handleScrollY,
          handleScrollX = _this$props13.handleScrollX,
          onBodyScroll = _this$props13.onBodyScroll;
      var headTable = this.headTable,
          bodyTable = this.bodyTable,
          bottomTable = this.bottomTable,
          fixedLeftBodyInner = this.fixedLeftBodyInner,
          fixedRightBodyInner = this.fixedRightBodyInner; // Prevent scrollTop setter trigger onScroll event
      // http://stackoverflow.com/q/1386696

      /*
      if (this.scrollTarget && e.target !== this.scrollTarget && e.target !== headTable) {//仅body区域滚动生效，头部区域滚动无需处理
        return;
      }
      */

      if (this.lastScrollLeft == undefined) this.lastScrollLeft = 0;
      if (this.lastScrollTop == undefined) this.lastScrollTop = 0; //水平滚动的逻辑处理

      if (e.target.scrollLeft !== this.lastScrollLeft && (e.target == bodyTable || e.target == headTable)) {
        if (e.target === bodyTable) {
          //中间内容中的水平滚动
          if (headTable) headTable.scrollLeft = e.target.scrollLeft;
          if (bottomTable) bottomTable.scrollLeft = e.target.scrollLeft;
        } else if (e.target === headTable && bodyTable) {
          bodyTable.scrollLeft = e.target.scrollLeft;
        }

        if (e.target.scrollLeft === 0) {
          this.setState({
            scrollPosition: 'left'
          });
        } else if (e.target.scrollLeft + 1 >= e.target.querySelector('table').getBoundingClientRect().width - e.target.getBoundingClientRect().width) {
          this.setState({
            scrollPosition: 'right'
          });
        } else if (this.state.scrollPosition !== 'middle') {
          this.setState({
            scrollPosition: 'middle'
          });
        }

        if (handleScrollX) {
          //触发props.handleScrollX
          debounce(handleScrollX(e.target.scrollLeft, this.treeType), 300);
        }

        this.lastScrollLeft = e.target.scrollLeft; //记录最后一次水平滚动位置
      } //垂直滚动的逻辑处理


      if (this.lastScrollTop !== e.target.scrollTop && (e.target == bodyTable || e.target == fixedLeftBodyInner || e.target == fixedRightBodyInner) //仅对此三个区域的垂直滚动条进行同步，以防止水平滚动时，scrollTop>0时被重置为0的问题
      ) {
        // console.log("AAA---handleBodyScroll-->垂直滚动："+e.target.scrollTop+"---lastScrollTop:"+this.lastScrollTop,e.target);
        if (fixedLeftBodyInner && e.target !== fixedLeftBodyInner) {
          fixedLeftBodyInner.scrollTop = e.target.scrollTop;
        }

        if (fixedRightBodyInner && e.target !== fixedRightBodyInner) {
          fixedRightBodyInner.scrollTop = e.target.scrollTop;
        }

        if (bodyTable && e.target !== bodyTable) {
          // console.log("AAA---handleBodyScroll-->中间内容垂直滚动："+e.target.scrollTop);
          bodyTable.scrollTop = e.target.scrollTop;
        } //注意快速滚动时将行的hover效果隐藏，timeout之后还原，以解决固定列情况下表格滚动时hover效果错位的问题。


        if (!this.state.currentHoverKey) {
          this.store.setState({
            currentHoverKey: null
          });
          clearTimeout(this.scrollHoverKeyTimer);
          this.scrollHoverKeyTimer = setTimeout(function () {
            _this7.store.setState({
              currentHoverKey: _this7.hoverKey
            });
          }, 100);
        }

        this.hideHoverDom(e); //隐藏外部自定义悬浮dom

        this.lastScrollTop = e.target.scrollTop; //记录最后一次垂直滚动位置

        if (handleScrollY) {
          //触发props.handleScrollY
          debounce(handleScrollY(this.lastScrollTop, this.treeType, onBodyScroll), 300);
        } else {
          onBodyScroll(this.lastScrollTop); //触发props.onBodyScroll滚动回调
        }
      }
    }
  }, {
    key: "handleRowHover",
    value: function handleRowHover(isHover, key, event, currentIndex, propsRecord) {
      var _this8 = this;

      //增加新的API，设置是否同步Hover状态，提高性能，避免无关的渲染
      var _this$props14 = this.props,
          syncHover = _this$props14.syncHover,
          onRowHover = _this$props14.onRowHover,
          data = _this$props14.data,
          lazyLoad = _this$props14.lazyLoad; //fix:树形表，onRowHover返回参数异常

      var isTreeType = this.isTreeType;
      var record = isTreeType ? propsRecord : lazyLoad ? data.find(function (item, index) {
        var rowKey = item.key ? item.key : _this8.getRowKey(item, index);
        return rowKey === key;
      }) : data[currentIndex];
      this.hoverKey = key; // 固定列、或者含有hoverdom时情况下同步hover状态

      if (this.columnManager.isAnyColumnsFixed() && syncHover) {
        this.store.setState({
          currentHoverKey: isHover ? key : null
        });
      }

      if (this.hoverDom) {
        if (isHover) {
          this.currentHoverKey = key;
          var td = closest(event.target, 'td');

          if (td) {
            var scrollTop = this.lastScrollTop ? this.lastScrollTop : 0;
            var top = td.offsetTop - scrollTop;

            if (this.headTable) {
              top = top + this.headTable.clientHeight;
            }

            this.hoverDom.style.top = top + 'px';
            this.hoverDom.style.height = td.offsetHeight + 'px';
            this.hoverDom.style.lineHeight = td.offsetHeight + 'px';
            this.hoverDom.style.display = 'block';
          }

          this.setState({
            currentHoverIndex: currentIndex,
            currentHoverRecord: record
          });
        }
      }

      onRowHover && onRowHover(currentIndex, record);
    }
  }, {
    key: "render",
    value: function render() {
      var _this9 = this;

      var _this$state2 = this.state,
          currentHoverRecord = _this$state2.currentHoverRecord,
          currentHoverIndex = _this$state2.currentHoverIndex;
      var props = this.props;
      var clsPrefix = props.clsPrefix;
      var hasFixedLeft = this.columnManager.isAnyColumnsLeftFixed();
      var hasFixedRight = this.columnManager.isAnyColumnsRightFixed();
      var className = props.clsPrefix;

      if (props.className) {
        className += " ".concat(props.className);
      }

      if (props.useFixedHeader || props.scroll && props.scroll.y) {
        className += " ".concat(clsPrefix, "-fixed-header");
      }

      if (!props.showHeader) {
        className += " ".concat(clsPrefix, "-hide-header");
      }

      if (props.bordered) {
        className += " ".concat(clsPrefix, "-bordered");
      }

      if (props.onCopy) {
        className += " copy";
      }

      className += " ".concat(clsPrefix, "-scroll-position-").concat(this.state.scrollPosition); //如果传入height说明是固定高度
      //内容过多折行显示时，height 属性会失效，为了避免产生错行

      if (props.bodyDisplayInRow && props.height) {
        className += ' fixed-height';
      }

      if (props.bodyDisplayInRow) {
        className += ' body-dispaly-in-row';
      }

      if (props.headerDisplayInRow) {
        className += ' header-dispaly-in-row';
      }

      var isTableScroll = this.columnManager.isAnyColumnsFixed() || props.scroll.x || props.scroll.y;
      var loading = props.loading;

      if (typeof loading === 'boolean') {
        loading = {
          show: loading
        };
      }

      if (props.size) {
        className += " ".concat(clsPrefix, "-").concat(props.size);
      }

      if (hasFixedLeft) {
        className += " has-fixed-left";
      }

      if (hasFixedRight) {
        className += " has-fixed-right";
      }

      return /*#__PURE__*/React.createElement("div", {
        className: className,
        style: props.style,
        ref: function ref(el) {
          return _this9.contentTable = el;
        },
        tabIndex: props.focusable && (props.tabIndex ? props.tabIndex : '0'),
        onMouseLeave: this.onTableHoverMouseLeave
      }, this.getTitle(), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-content")
      }, /*#__PURE__*/React.createElement("div", {
        className: isTableScroll ? "".concat(clsPrefix, "-scroll") : ''
      }, this.getTable({
        columns: this.columnManager.groupedColumns()
      }), this.getEmptyText(), this.getFooter()), hasFixedLeft && /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-fixed-left")
      }, this.getLeftFixedTable()), hasFixedRight && /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-fixed-right")
      }, this.getRightFixedTable())), props.dragborder ? /*#__PURE__*/React.createElement(DragResizerLine, {
        key: "DragResizerLine_" + this.tableUid,
        ref: function ref(line) {
          return _this9.resizerLine = line;
        },
        container: this,
        clsPrefix: clsPrefix,
        left: this.state.resizerLineLeft,
        height: this.state.resizerLineHeight,
        defaultWidth: this.state.resizerDefaultWidth,
        minWidth: this.state.resizerMinWidth,
        visible: this.state.resizerVisible,
        onChange: this.onDragBorderMouseMove,
        onResizeEnd: this.onDragBorderMouseUp,
        onResizeCancel: this.onDragBorderCancel,
        dataSource: this.state.dataSource
      }) : null, /*#__PURE__*/React.createElement(Loading, _extends({
        container: this
      }, loading)), props.hoverContent && /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-row-hover"),
        onMouseEnter: this.onRowHoverMouseEnter,
        onMouseLeave: this.onRowHoverMouseLeave,
        ref: function ref(el) {
          return _this9.hoverDom = el;
        }
      }, currentHoverRecord ? props.hoverContent(currentHoverRecord, currentHoverIndex) : null));
    }
  }]);

  return Table;
}(Component)) || _class);
;
Table.propTypes = propTypes;
Table.contextTypes = {
  beeLocale: PropTypes.object
};
export default Table;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-table/src/Table.js